var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 280,
    viewBox: "0 0 500 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 271H439C439 271 361.445 256.681 298.742 254.264C227.634 251.523 64 271 64 271Z",
    fill: "#BAD8F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.8335 154.762C21.101 144.046 28.5427 134.89 38.6169 131.791C53.7163 127.051 72.0559 123.965 76.2235 104.256C77.7367 97.1009 77.501 89.6519 78.22 82.3474C78.94 75.0428 80.8318 67.4506 85.6518 62.3799C94.4387 53.1352 106.954 56.3175 117.142 60.1208C120.807 61.4881 124.438 62.7699 127.94 63.4138C133.048 64.5404 138.254 64.0312 143.071 62.1789C151.929 59.04 157.499 50.5968 163.439 43.2706C170.162 34.9779 178.669 29.5341 188.911 28.6783C198.691 27.8611 207.304 31.0277 214.731 38.1578C220.883 44.0638 225.829 51.3695 231.963 57.3008C238.084 63.22 245.459 67.7335 253.457 69.4052C264.455 71.7053 275.658 67.8021 283.384 58.8979C291.653 49.3656 296.257 36.7038 305.279 27.4711C321.934 10.4272 345.427 8.15602 366.726 13.6865C388.484 19.3361 412.838 32.667 426.024 53.193C441.163 76.7616 435.541 107.627 420.425 129.412C418.755 132.195 417.174 135.013 416.055 138.125C414.595 142.204 414.692 146.82 416.834 150.792C418.975 154.763 422.478 157.339 426.468 157.662C436.489 158.52 448.263 154.978 455.951 164.746C468.6 180.633 468.113 203.282 461.079 221.399C460.095 224.084 459.001 226.734 457.836 229.352C454.339 237.205 450.199 244.772 446.398 252.148C444.348 255.91 442.163 259.536 439.829 263.015C437.495 266.495 435.014 269.83 432.396 273H53.977C47.4485 273 42.791 261.521 43.8973 253.76C44.8574 247.021 49.5017 241.816 50.9506 235.205C51.8354 231.167 51.4317 227.135 50.1749 223.353C46.4928 212.277 37.6143 206.598 30.0264 199.264C22.1898 191.689 16.7501 180.857 16.0682 169.29C15.7802 164.399 16.4108 159.433 17.8345 154.765L17.8335 154.762Z",
    fill: "url(#paint0_linear_4157_9738)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196.581 256.613C196.581 256.613 196.666 256.571 196.82 256.505C196.772 256.572 196.723 256.641 196.675 256.708C196.613 256.647 196.581 256.614 196.581 256.614V256.613Z",
    fill: "url(#paint1_linear_4157_9738)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.581 256.613C196.581 256.613 196.666 256.571 196.82 256.505C196.772 256.572 196.723 256.641 196.675 256.708C196.613 256.647 196.581 256.614 196.581 256.614V256.613Z",
    fill: "url(#paint2_linear_4157_9738)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.371 256.578C196.376 256.57 196.381 256.564 196.386 256.556C196.381 256.574 196.378 256.584 196.378 256.584C196.378 256.584 196.376 256.581 196.371 256.578Z",
    fill: "url(#paint3_linear_4157_9738)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.371 256.578C196.376 256.57 196.381 256.564 196.386 256.556C196.381 256.574 196.378 256.584 196.378 256.584C196.378 256.584 196.376 256.581 196.371 256.578Z",
    fill: "url(#paint4_linear_4157_9738)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M303.312 266.631C303.333 266.696 303.354 266.761 303.375 266.827C303.437 266.798 303.469 266.782 303.469 266.782C303.469 266.782 303.413 266.726 303.312 266.631Z",
    fill: "url(#paint5_linear_4157_9738)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M303.312 266.631C303.333 266.696 303.354 266.761 303.375 266.827C303.437 266.798 303.469 266.782 303.469 266.782C303.469 266.782 303.413 266.726 303.312 266.631Z",
    fill: "url(#paint6_linear_4157_9738)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M303.714 266.802C303.7 266.758 303.686 266.713 303.672 266.67C303.665 266.767 303.663 266.82 303.663 266.82C303.663 266.82 303.682 266.813 303.715 266.802H303.714Z",
    fill: "url(#paint7_linear_4157_9738)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M303.714 266.802C303.7 266.758 303.686 266.713 303.672 266.67C303.665 266.767 303.663 266.82 303.663 266.82C303.663 266.82 303.682 266.813 303.715 266.802H303.714Z",
    fill: "url(#paint8_linear_4157_9738)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.784 265.589C153.784 265.589 153.269 266.642 153.155 268.103C153.099 268.81 153.097 269.498 153.11 270.018C153.124 270.541 153.614 271.027 154.249 271.148C157.558 271.773 165.842 273.25 170.019 272.957C171.025 272.887 171.969 270.942 168.987 269.951C166.004 268.961 160.169 265.062 160.169 265.062L153.784 265.588V265.589Z",
    fill: "url(#paint9_linear_4157_9738)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M175.661 265.589C175.661 265.589 175.138 266.642 175.021 268.103C174.964 268.81 174.963 269.498 174.976 270.018C174.989 270.541 175.487 271.027 176.134 271.148C179.497 271.773 187.92 273.25 192.166 272.957C193.188 272.887 194.148 270.942 191.115 269.951C188.083 268.961 181.949 265.062 181.949 265.062L175.66 265.588L175.661 265.589Z",
    fill: "url(#paint10_linear_4157_9738)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.714 132.401C180.737 127.918 192.53 134.184 202.178 129.905C202.192 129.898 202.206 129.892 202.221 129.886C206.23 123.062 208.164 112.865 207.958 107.321C207.954 105.518 207.829 104.19 207.69 103.566C207.023 100.735 208.881 100.214 210.028 102.601C210.312 103.225 210.904 104.974 211.425 107.57C211.826 109.579 212.101 111.618 212.226 113.677C212.381 116.244 212.326 118.836 212.058 121.408C211.761 124.273 211.194 127.119 210.34 129.873C209.723 131.864 208.947 133.803 208.021 135.664C207.819 136.066 207.609 136.378 207.228 136.598C206.764 136.866 206.308 137.15 205.838 137.407C204.854 137.945 203.845 138.424 202.815 138.841C186.784 144.801 176.26 136.078 178.717 132.401H178.714Z",
    fill: "url(#paint11_linear_4157_9738)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M207.374 136.922C207.168 137.041 206.964 137.163 206.758 137.284C206.506 137.435 206.243 137.589 205.978 137.733C204.975 138.28 203.945 138.766 202.919 139.18C190.269 144.036 180.605 139.271 178.551 135.371C177.945 134.24 177.909 133.128 178.435 132.222C179.668 129.681 183.395 130.311 188.297 130.812C192.593 131.254 197.591 131.564 201.995 129.599C205.393 123.713 207.354 115.381 207.595 109.637C207.609 109.37 207.784 109.162 208.02 109.127C208.793 109.018 210.511 108.752 211.642 108.621C211.806 108.602 211.962 108.737 211.994 108.923C212.266 110.523 212.45 112.115 212.545 113.666C212.702 116.236 212.649 118.865 212.38 121.454C212.074 124.408 211.488 127.29 210.652 129.987C210.03 131.995 209.241 133.966 208.312 135.832C208.112 136.232 207.858 136.643 207.373 136.923L207.374 136.922Z",
    fill: "#785BCA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M207.966 107.637C207.96 108.139 207.951 108.643 207.938 109.147C209.17 108.991 210.406 108.816 211.643 108.621C211.527 108.05 211.408 107.48 211.286 106.912C210.179 107.172 209.072 107.413 207.966 107.638V107.637Z",
    fill: "url(#paint12_linear_4157_9738)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M182.981 164.663C186.32 164.503 189.658 164.343 192.995 164.184C193.203 164.149 196.191 188.462 196.234 192.994C197.067 208.537 192.321 220.983 191.499 223.372C191.495 223.386 191.49 223.399 191.485 223.413C191.242 224.109 191.058 224.826 190.918 225.555C190.813 226.111 190.624 226.729 190.344 227.414C188.861 231.285 186.27 247.156 185.434 253.154C184.616 259.033 184.164 266.398 184.156 266.401C181.354 266.412 177.326 266.401 174.525 266.401C174.576 266.398 175.873 251.265 176.669 243.579C177.194 239.141 177.988 230.919 180.452 225.709C181.176 224.189 181.559 222.507 181.533 220.805C181.523 220.148 181.544 219.433 181.593 218.654C181.966 213.242 181.278 203.597 180.681 200.397C180.435 199.004 179.62 194.631 179.379 190.024C179.243 187.363 178.78 184.733 178.105 182.16C178.076 182.05 178.048 181.938 178.02 181.825C176.285 174.594 181.137 166.858 182.981 164.663Z",
    fill: "#0787BE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M192.925 164.175C192.896 163.743 192.828 162.655 192.882 162.112C193.143 159.47 193.291 156.733 193.415 154.082C193.492 152.414 193.566 150.688 193.654 148.998C193.979 142.716 193.057 138.17 190.868 134.779C188.336 130.857 183.645 128.925 178.38 129.535C177.692 129.614 177.001 129.737 176.326 129.9C175.046 130.13 174.372 130.45 174.366 130.452C174.362 130.454 174.359 130.455 174.356 130.457C174.352 130.459 174.348 130.46 174.345 130.461C170.809 131.572 167.3 134.619 167.38 138.326C167.35 138.809 167.353 139.31 167.389 139.83C167.546 142.08 168.306 144.779 169.69 148.114C173.591 157.535 175.09 164.177 175.328 165.207C181.194 164.864 187.06 164.521 192.926 164.175H192.925Z",
    fill: "url(#paint13_linear_4157_9738)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M174.303 130.358C170.527 131.547 167.143 134.763 167.221 138.39C167.191 138.862 167.193 139.365 167.23 139.903C167.379 142.05 168.093 144.745 169.544 148.243C173.819 158.583 175.189 165.462 175.2 165.449C181.168 165.103 187.138 164.755 193.106 164.406C193.106 164.406 192.984 162.86 193.049 162.197C193.475 157.886 193.595 153.45 193.823 149.075C194.079 144.242 193.672 138.863 191.01 134.745C187.743 129.69 181.583 128.512 176.294 129.796C174.982 130.03 174.301 130.36 174.301 130.36L174.303 130.358Z",
    fill: "#785BCA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M176.277 127.035C176.825 125.76 176.803 123.287 176.727 122.743C176.553 121.408 176.132 118.722 175.941 118.782C175.941 118.785 179.226 117.746 181.197 119.702C181.32 119.824 181.437 119.945 181.55 120.065C181.662 120.187 181.77 120.306 181.873 120.423C182.649 121.279 184.392 123.617 184.39 123.619C184.39 123.619 183.319 123.723 183.404 125.562C183.472 126.993 184.613 129.89 184.611 129.891C184.611 129.891 184.482 131.019 183.344 131.486C182.997 131.694 182.515 131.845 181.89 131.889C181.874 131.892 181.858 131.896 181.84 131.899C178.998 132.432 176.068 130.931 175.625 130.697C175.183 130.457 174.701 130.135 174.701 130.135C174.701 130.135 175.731 128.309 176.276 127.033L176.277 127.035Z",
    fill: "url(#paint14_linear_4157_9738)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M157.757 244.14C159.101 240.077 161.842 232.268 165.376 227.113C166.62 225.311 167.488 223.287 167.887 221.146C167.975 220.672 168.084 220.17 168.214 219.64C169.56 214.253 169.896 204.553 169.787 201.323C169.784 201.239 169.798 201.086 169.823 200.87C169.913 196.165 170.212 189.273 171.42 179.499C172.465 170.986 175.666 165.046 175.674 165.04C175.674 165.04 176.005 165.108 176.034 165.022C180.418 164.806 184.802 164.59 189.186 164.373C189.252 164.371 189.539 171.839 189.591 174.567C189.684 176.299 189.373 189.599 188.834 193.857C187.068 209.671 179.576 222.039 178.229 224.405C178.212 224.434 178.195 224.463 178.179 224.492C177.823 225.106 177.499 225.74 177.262 226.406C177.051 227.001 176.711 227.668 176.234 228.415C173.878 232.273 168.23 248.326 165.911 253.943C163.688 259.618 162.136 266.294 162.129 266.291C159.445 266.222 155.384 266.261 152.701 266.183C152.748 266.187 155.383 251.642 157.755 244.141L157.757 244.14Z",
    fill: "#078FCA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M175.62 133.149C178.096 137.345 168.148 144.126 165.398 153.1C165.394 153.113 165.39 153.126 165.385 153.14C167.477 159.622 171.667 167.213 174.479 171.078C175.372 172.348 176.089 173.239 176.486 173.61C178.309 175.298 177.144 176.817 175.216 175.728C174.72 175.442 173.49 174.513 171.873 173.03C170.622 171.88 169.422 170.681 168.288 169.421C166.873 167.849 165.543 166.205 164.306 164.497C162.929 162.597 161.666 160.618 160.55 158.564C159.742 157.079 159.024 155.653 158.386 154.09C158.248 153.75 158.173 153.453 158.248 153.086C158.342 152.639 158.416 152.187 158.513 151.74C158.715 150.801 158.948 149.767 159.225 148.841C163.459 134.786 173.528 129.058 175.62 133.149Z",
    fill: "url(#paint15_linear_4157_9738)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M174.952 166.57C181.033 166.283 187.115 165.997 193.196 165.711C193.153 164.782 193.106 163.853 193.059 162.924C186.978 163.241 180.899 163.557 174.818 163.874C174.865 164.773 174.91 165.671 174.952 166.57Z",
    fill: "#5434AF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M157.957 153.024C157.998 152.826 158.036 152.627 158.073 152.428C158.12 152.182 158.168 151.927 158.221 151.676C158.427 150.72 158.665 149.671 158.94 148.752C162.317 137.627 169.368 131.5 173.403 131.548C174.533 131.563 175.411 132.077 175.875 132.997C177.279 135.373 175.098 138.344 172.29 142.012C169.816 145.247 166.988 148.951 165.696 153.14C167.51 158.737 170.863 165.075 173.573 169.237C173.698 169.43 173.682 169.685 173.533 169.858C173.045 170.425 171.957 171.671 171.208 172.439C171.099 172.551 170.922 172.552 170.808 172.444C169.84 171.518 168.92 170.573 168.067 169.625C166.653 168.055 165.307 166.389 164.066 164.675C162.649 162.72 161.378 160.714 160.288 158.708C159.476 157.215 158.747 155.767 158.11 154.203C157.973 153.867 157.86 153.492 157.957 153.025V153.024Z",
    fill: "#785BCA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M174.317 170.862C174.072 170.503 173.828 170.146 173.582 169.79C172.793 170.677 172.002 171.559 171.208 172.438C171.567 172.759 171.927 173.081 172.286 173.403C172.965 172.56 173.642 171.713 174.317 170.863V170.862Z",
    fill: "url(#paint16_linear_4157_9738)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M184.299 128.68C183.802 129.714 183.303 130.747 182.799 131.776C183.364 132.4 183.927 133.027 184.49 133.656C184.9 132.537 185.307 131.415 185.711 130.292C185.241 129.753 184.77 129.216 184.298 128.681L184.299 128.68Z",
    fill: "#078FCA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M175.571 128.518C177.984 129.587 180.393 130.672 182.801 131.776C182.439 132.619 182.076 133.461 181.71 134.301C179.291 132.926 176.867 131.571 174.438 130.236C174.817 129.664 175.194 129.092 175.571 128.518Z",
    fill: "#078FCA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M179.084 120.619C180.447 120.691 180.99 123.539 184.917 123.702C186.932 123.785 187.095 123.576 187.416 121.523C187.748 119.539 186.809 110.727 182.782 109.257C178.775 107.783 174.681 108.682 173.335 111.836C171.995 114.994 172.932 120.287 179.085 120.619H179.084Z",
    fill: "url(#paint17_linear_4157_9738)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M172.018 113.787C172.043 113.158 172.083 112.493 172.22 111.871C172.363 111.245 172.591 110.665 172.984 110.212C173.331 109.705 173.759 109.252 174.233 108.857C175.653 107.675 177.48 107.042 179.239 107.195C179.242 107.195 181.815 107.477 183.442 107.32C184.617 107.206 185.446 107.844 185.921 108.427C186.845 109.563 186.269 110.966 185.29 111.108C185.082 111.138 184.898 111.156 184.728 111.175C183.368 111.145 181.848 111.275 180.878 112.367C180.321 112.996 180.112 113.804 180.399 114.635C180.528 115.008 180.735 115.314 180.913 115.618C180.908 115.622 180.905 115.628 180.9 115.631C180.798 115.728 180.684 115.809 180.577 115.898C180.325 116.106 180.092 116.337 179.848 116.553C179.708 116.507 179.559 116.454 179.401 116.4C178.8 116.192 178.483 116.303 178.405 116.721C178.328 117.14 178.491 117.865 178.846 118.887C179.024 119.399 178.962 119.851 178.77 120.239C178.579 120.629 176.823 122.416 176.625 122.015C175.649 120.048 173.808 118.992 172.542 115.806C172.28 115.15 172.08 114.474 172.017 113.785L172.018 113.787Z",
    fill: "url(#paint18_linear_4157_9738)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M182.557 112.305C182.443 112.369 182.329 112.43 182.213 112.487C181.315 112.93 180.284 113.256 179.279 113.174C178.004 113.071 176.738 112.893 175.483 113.22C173.951 113.62 173.41 115.044 172.886 116.587C172.143 116.203 171.584 114.73 171.647 113.836C171.941 109.708 175.719 106.893 179.241 107.194C179.243 107.194 181.816 107.476 183.443 107.32C184.618 107.205 185.447 107.843 185.922 108.426C186.846 109.562 186.27 110.965 185.292 111.107C184.911 111.163 184.514 111.166 184.143 111.283C183.806 111.39 183.56 111.636 183.279 111.84C183.047 112.008 182.807 112.163 182.559 112.303L182.557 112.305Z",
    fill: "url(#paint19_linear_4157_9738)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M172.018 113.787C172.043 113.158 172.083 112.493 172.22 111.871C172.363 111.245 172.591 110.665 172.984 110.212C173.331 109.705 173.759 109.252 174.233 108.857C175.653 107.675 177.48 107.042 179.239 107.195C179.242 107.195 181.815 107.477 183.442 107.32C184.617 107.206 185.446 107.844 185.921 108.427C186.845 109.563 186.269 110.966 185.29 111.108C185.082 111.138 184.898 111.156 184.728 111.175C183.368 111.145 181.848 111.275 180.878 112.367C180.321 112.996 180.112 113.804 180.399 114.635C180.528 115.008 180.735 115.314 180.913 115.618C180.908 115.622 180.905 115.628 180.9 115.631C180.798 115.728 180.684 115.809 180.577 115.898C180.325 116.106 180.092 116.337 179.848 116.553C179.708 116.507 179.559 116.454 179.401 116.4C178.8 116.192 178.483 116.303 178.405 116.721C178.328 117.14 178.491 117.865 178.846 118.887C179.024 119.399 178.962 119.851 178.77 120.239C178.579 120.629 176.823 122.416 176.625 122.015C175.649 120.048 173.808 118.992 172.542 115.806C172.28 115.15 172.08 114.474 172.017 113.785L172.018 113.787Z",
    fill: "url(#paint20_linear_4157_9738)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M180.306 117.374C180.246 116.774 179.851 116.25 179.298 116.098C178.837 115.971 178.391 116.106 178.436 117.141C178.525 119.211 180.518 119.541 180.519 119.541C180.449 118.818 180.378 118.096 180.306 117.373V117.374Z",
    fill: "url(#paint21_linear_4157_9738)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M202.918 102.618C202.963 102.522 203.072 102.457 203.181 102.444C203.309 102.428 203.436 102.467 203.56 102.507C204.336 102.763 205.12 103.08 205.849 103.479C205.619 102.873 205.447 102.277 205.389 101.769C205.217 100.947 203.584 95.548 204.556 95.2666C204.859 95.1787 206.004 98.5537 206.575 100.306C208.648 100.054 209.794 99.3157 210.538 100.595C211.328 101.953 211.213 106.762 211.213 106.762C211.213 106.762 209.46 107.246 208.426 107.206C207.417 107.59 204.764 104.364 204.276 103.986C203.845 103.651 203.334 103.436 203.006 102.981C202.941 102.891 202.881 102.785 202.901 102.676C202.905 102.657 202.91 102.639 202.919 102.621L202.918 102.618Z",
    fill: "url(#paint22_linear_4157_9738)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M177.383 175.034C175.702 175.739 174.602 176.926 174.317 177.408C174.033 177.89 174.515 178.484 175.368 178.409C176.221 178.335 177.229 178.286 177.835 177.838C178.442 177.392 180.051 175.958 179.861 175.033C179.67 174.107 177.384 175.033 177.384 175.033L177.383 175.034Z",
    fill: "url(#paint23_linear_4157_9738)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M178.7 173.53C179.515 174.276 180.044 174.942 179.854 175.518C179.591 176.318 177.596 178.954 175.894 178.002C174.193 177.05 172.323 173.428 172.323 173.428L173.856 172.168C174.804 171.196 177.883 172.784 178.698 173.529L178.7 173.53Z",
    fill: "url(#paint24_linear_4157_9738)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M255.837 139.225C251.7 140.187 255.361 149.091 251.727 161.132C250.465 165.317 248.102 170.347 245.876 174.563C243.652 178.776 241.564 182.176 240.847 183.108C239.412 184.973 240.116 186.254 241.625 184.972C242.409 184.306 245.294 181.016 248.496 176.254C251.456 171.852 254.685 166.191 256.777 160.179C261.131 147.661 259.039 138.48 255.836 139.224L255.837 139.225Z",
    fill: "url(#paint25_linear_4157_9738)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M262.849 168.17H253.894C253.853 168.17 251.006 191.383 250.623 195.653C249.302 210.36 252.377 222.362 252.893 224.72C252.896 224.733 252.899 224.747 252.902 224.76C253.054 225.438 253.152 226.133 253.207 226.836C253.248 227.373 253.358 227.973 253.538 228.646C254.552 232.42 255.295 248.028 255.483 253.717C255.671 259.406 255.356 267.661 255.356 267.661H260.581C260.581 267.661 262.155 252.261 263.196 245.185C263.832 240.856 263.761 232.839 262.057 227.618C261.56 226.096 261.375 224.442 261.548 222.79C261.614 222.151 261.658 221.455 261.679 220.696C261.828 215.424 263.499 206.059 264.175 202.937C264.57 201.114 266.15 194.014 265.904 188.132C266.468 187.223 266.896 186.095 267.214 184.757C268.917 177.597 264.529 170.182 262.849 168.168V168.17Z",
    fill: "#F28B36"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M282.07 245.185C282.058 240.986 280.697 233.317 278.032 228.095C277.099 226.266 276.51 224.261 276.337 222.169C276.299 221.707 276.244 221.216 276.173 220.696C275.444 215.424 275.753 206.059 275.992 202.937C276.119 201.284 276.615 195.296 275.753 189.809C275.515 188.292 275.617 186.728 276.066 185.236C276.112 185.079 276.158 184.919 276.201 184.757C278.105 177.597 273.069 170.182 271.147 168.168H257.227C257.349 168.235 257.801 188.626 259.15 195.652C261.929 210.129 265.862 222.361 266.852 224.719C266.864 224.748 266.876 224.776 266.888 224.805C267.15 225.407 267.38 226.027 267.53 226.673C267.664 227.251 267.903 227.905 268.255 228.646C270.052 232.42 273.556 248.028 274.739 253.717C275.921 259.406 277.539 267.661 277.539 267.661H282.754C282.754 267.661 282.091 252.261 282.07 245.185Z",
    fill: "#F99746"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M255.78 265.267C254.887 265.267 255.654 266.477 253.432 268.166C251.218 269.849 249.41 270.449 249.41 270.449C249.41 270.449 247.183 270.928 246.92 271.646C246.656 272.362 246.969 273.91 246.969 273.91C246.969 273.91 249.502 275.216 254.213 273.91C258.938 272.6 257.967 273.196 259.639 273.077C261.312 272.958 261.726 272.362 261.726 272.362C261.726 272.362 261.707 269.129 261.281 268.167C260.993 267.516 261.561 266.039 261.526 265.145C261.512 264.821 261.14 264.598 260.786 264.705C260.435 264.811 259.267 264.928 258.59 265.026C257.466 265.187 256.53 265.268 255.78 265.268V265.267Z",
    fill: "url(#paint26_linear_4157_9738)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M255.914 264.677C254.786 264.54 254.844 267.217 253.097 268.414C251.354 269.608 249.41 270.448 249.41 270.448C249.41 270.448 249.836 270.807 250.671 270.568C251.506 270.329 254.735 268.661 255.682 267.267C256.63 265.872 257.041 264.815 255.913 264.677H255.914Z",
    fill: "url(#paint27_linear_4157_9738)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M277.672 263.857C276.796 264.022 277.82 265.068 276.02 267.137C274.228 269.197 272.593 270.118 272.593 270.118C272.593 270.118 270.522 270.998 270.425 271.75C270.328 272.501 270.98 273.962 270.98 273.962C270.98 273.962 273.75 274.778 278.074 272.631C282.418 270.474 281.598 271.239 283.214 270.814C284.832 270.388 285.105 269.725 285.105 269.725C285.105 269.725 284.361 266.549 283.726 265.682C283.297 265.096 282.865 263.663 282.628 262.791C282.542 262.475 282.126 262.326 281.801 262.497C281.481 262.666 281.019 262.873 280.375 263.096C279.309 263.464 278.408 263.717 277.672 263.856V263.857Z",
    fill: "url(#paint28_linear_4157_9738)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M277.451 263.326C277.443 263.328 277.436 263.332 277.429 263.335C277.386 263.353 277.351 263.377 277.315 263.404C276.421 264.086 276.739 265.281 276.496 266.169C276.416 266.397 276.319 266.623 276.197 266.838C276.075 267.053 275.927 267.257 275.747 267.444C274.306 268.938 272.592 270.119 272.592 270.119C272.592 270.119 273.089 270.393 273.852 270.005C274.463 269.693 276.371 268.204 277.425 266.83C277.558 266.658 277.676 266.487 277.777 266.322C278.093 265.803 278.305 265.229 278.278 264.641C278.263 264.296 278.114 263.078 277.449 263.326H277.451Z",
    fill: "url(#paint29_linear_4157_9738)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M259.52 157.365C260.371 151.734 260.344 143.322 258.024 139.998C257.512 139.266 256.875 138.885 256.197 138.885C256.056 138.885 255.912 138.902 255.77 138.935C253.384 139.489 253.595 142.3 253.288 146.529C252.867 152.337 252.679 154.478 252.376 156.243C254.406 156.35 257.536 156.915 259.52 157.366V157.365Z",
    fill: "url(#paint30_linear_4157_9738)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M267.904 135.584C271.127 136.241 274.202 138.861 274.41 142.273C274.47 142.711 274.505 143.183 274.514 143.69C274.547 145.715 274.143 148.315 273.149 151.711C270.216 161.737 268.774 168.169 268.774 168.169H254.344C254.344 168.169 254.392 166.769 254.314 166.177C254.235 165.584 254.116 164.738 253.988 163.728C253.673 160.219 253.738 158.797 253.174 155.277C253.079 154.687 252.986 154.095 252.893 153.5C252.853 152.144 252.639 150.68 252.449 149.196C252.385 148.7 252.324 148.202 252.273 147.704C251.742 145.226 252.283 142.922 253.509 140.977C253.816 140.489 254.166 140.024 254.553 139.585C257.523 136.728 261.839 134.738 266.209 135.293C267.314 135.36 267.904 135.585 267.904 135.585V135.584Z",
    fill: "url(#paint31_linear_4157_9738)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M254.623 141.693C254.623 141.693 251.112 146.433 250.317 148.561C249.542 150.633 252.865 153.602 252.865 153.602C252.865 153.602 255.287 152.903 255.635 148.584C256.003 144.015 254.622 141.692 254.622 141.692L254.623 141.693Z",
    fill: "url(#paint32_linear_4157_9738)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M273.39 151.998C274.244 148.851 274.799 145.561 274.598 142.261C274.439 139.649 272.71 137.591 270.587 136.397C270.411 136.42 270.252 136.451 270.118 136.492C268.2 137.083 265.47 140.845 260.033 140.938C256.855 140.991 255.867 139.594 255.592 138.422C255.185 138.748 254.79 139.094 254.408 139.461C254.011 139.912 253.654 140.388 253.347 140.878C252.553 142.139 252.339 143.585 251.899 144.973C251.491 146.254 250.603 147.257 250.14 148.498C249.332 150.659 252.601 153.611 252.74 153.736C252.74 153.736 253.888 161.559 253.334 162.924C252.781 164.289 253.878 165.285 253.878 165.285H271.084C271.084 165.285 272.221 164.916 271.778 163.367C271.336 161.819 270.875 159.695 271.528 157.521C272.138 155.681 272.889 153.859 273.391 152L273.39 151.998Z",
    fill: "url(#paint33_linear_4157_9738)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M271.184 165.284H253.878V168.236H271.184V165.284Z",
    fill: "#F99746"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M265.628 125.862C265.628 125.862 265.205 128.325 265.527 130.89C265.847 133.443 267.094 135.364 267.094 135.364C267.304 135.48 264.442 137.238 263.153 137.589C260.381 138.345 259.157 137.425 259.239 136.559C259.239 136.559 260.207 134.053 260.487 131.251C260.838 127.743 260.044 126.157 260.044 126.157L265.628 125.861V125.862Z",
    fill: "url(#paint34_linear_4157_9738)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M261.666 116.805C268.657 116.742 269.287 123.184 267.278 125.881C265.436 128.355 264.825 127.056 263.845 129.025C263.09 130.542 259.852 131.827 258.252 131.684C256.651 131.54 254.956 128.629 255.775 123.729C256.603 118.784 259.103 116.829 261.666 116.806V116.805Z",
    fill: "url(#paint35_linear_4157_9738)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M275.258 121.612C275.824 120.762 275.67 119.645 274.941 118.975C275.347 118.576 275.501 117.959 275.28 117.395C275.144 117.044 274.885 116.777 274.573 116.62C274.811 115.54 274.386 114.377 273.41 113.726C272.909 113.392 272.339 113.245 271.78 113.266C271.644 112.84 271.369 112.456 270.968 112.189C270.339 111.769 269.564 111.746 268.931 112.057C268.914 111.955 268.888 111.853 268.848 111.751C268.554 110.997 267.704 110.625 266.949 110.919C266.914 110.933 266.881 110.949 266.847 110.965C266.416 110.193 265.471 109.837 264.623 110.168C264.424 110.246 264.249 110.356 264.097 110.489C263.6 110.162 262.931 110.296 262.601 110.792C262.558 110.858 262.522 110.926 262.494 110.997C262.488 110.993 262.481 110.987 262.474 110.983C261.679 110.452 260.604 110.667 260.074 111.462C259.981 111.601 259.913 111.748 259.865 111.899C259.51 111.726 259.086 111.695 258.689 111.849C258.242 112.024 257.93 112.394 257.811 112.824C257.472 112.68 257.079 112.662 256.709 112.807C255.971 113.095 255.601 113.915 255.862 114.656C255.691 114.737 255.538 114.863 255.425 115.032C255.284 115.243 255.228 115.487 255.248 115.723C254.91 115.862 254.608 116.1 254.39 116.427C253.805 117.305 254.042 118.489 254.92 119.074C255.032 119.149 255.15 119.21 255.27 119.259C255.266 119.266 255.259 119.272 255.255 119.28C254.805 119.954 254.988 120.865 255.662 121.315C256.217 121.685 256.932 121.626 257.418 121.218C257.769 121.667 258.384 121.854 258.941 121.637C259.114 121.57 259.264 121.471 259.387 121.348C259.402 121.359 259.415 121.37 259.431 121.38C259.847 121.659 260.385 121.608 260.744 121.294C260.861 121.454 261.006 121.597 261.181 121.713C261.382 121.847 261.6 121.933 261.824 121.974C261.63 122.694 261.901 123.487 262.557 123.924C262.849 124.119 263.178 124.215 263.505 124.223C263.474 124.602 263.645 124.986 263.984 125.212C264.038 125.248 264.096 125.278 264.154 125.303C264.036 125.404 263.928 125.521 263.838 125.656C263.307 126.452 263.522 127.526 264.318 128.057C264.328 128.064 264.338 128.068 264.346 128.075C264.055 128.567 264.195 129.205 264.677 129.527C264.831 129.629 265.002 129.687 265.174 129.703C265.215 129.943 265.348 130.165 265.566 130.311C265.985 130.591 266.552 130.478 266.832 130.057C266.865 130.007 266.892 129.956 266.914 129.903C267.517 130.196 268.259 130.007 268.64 129.434C268.645 129.428 268.648 129.42 268.653 129.413C269.002 129.576 269.415 129.601 269.803 129.45C270.296 129.257 270.624 128.828 270.712 128.343C271.519 128.534 272.396 128.221 272.883 127.49C273.138 127.107 273.245 126.67 273.221 126.243C273.823 126.067 274.369 125.688 274.744 125.125C275.369 124.188 275.344 123.009 274.779 122.116C274.96 121.98 275.123 121.813 275.257 121.614L275.258 121.612Z",
    fill: "url(#paint36_linear_4157_9738)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M270.217 137.983C266.127 140.227 271.479 149.125 272.977 162.398C273.505 167.085 273.726 173.045 274.102 178.214C274.444 183.372 274.574 187.74 274.578 189.04C274.594 191.651 276.049 192.249 276.448 190.123C276.67 189.017 277.192 184.269 277.418 178.219C277.607 172.602 277.863 165.9 277.55 159.314C276.933 145.778 273.581 136.451 270.218 137.983H270.217Z",
    fill: "url(#paint37_linear_4157_9738)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M271.318 156.197C272.825 156.32 274.595 156.08 276.051 155.761C276.711 155.616 278.149 155.155 278.798 154.953C277.551 147.335 274.416 137.669 271.047 137.669C270.777 137.669 270.506 137.74 270.242 137.861C270.235 137.864 270.229 137.867 270.222 137.871C267.536 139.345 268.331 143.275 269.869 149.17C270.03 149.782 271.149 155.536 271.318 156.198V156.197Z",
    fill: "url(#paint38_linear_4157_9738)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M237.602 183.744C236.925 184.432 235.907 185.021 236.226 185.445C236.382 185.652 237.276 185.138 238.116 184.71C237.604 185.263 237.203 185.801 237.006 186.186C236.414 187.341 235.544 187.42 235.261 187.632C234.979 187.845 233.763 188.23 233.99 188.59C234.217 188.95 238.186 189.105 239.627 188.196C241.067 187.287 243.161 183.365 243.161 183.365L241.765 182.335C240.892 181.531 238.278 183.057 237.601 183.744H237.602Z",
    fill: "url(#paint39_linear_4157_9738)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M272.435 191.299C272.285 192.252 271.801 193.324 272.307 193.482C272.555 193.56 272.981 192.62 273.415 191.784C273.322 192.531 273.308 193.203 273.373 193.63C273.564 194.913 272.904 195.485 272.798 195.822C272.692 196.159 271.928 197.18 272.323 197.34C272.718 197.5 276.033 195.314 276.675 193.736C277.316 192.159 276.731 187.75 276.731 187.75L274.997 187.727C273.82 187.581 272.584 190.344 272.434 191.298L272.435 191.299Z",
    fill: "url(#paint40_linear_4157_9738)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M111.264 120.173C111.264 119.907 111.136 119.658 110.919 119.505C110.109 118.932 108.014 117.689 106.18 118.63C103.847 119.826 102.71 124.014 103.548 128.979C104.123 132.392 103.258 134.844 102.66 136.043C102.452 136.461 102.638 136.968 103.066 137.154C103.707 137.432 104.542 137.969 105.043 138.969C105.689 140.261 107.143 140.529 107.905 140.578C108.214 140.598 108.507 140.439 108.662 140.17C109.158 139.303 110.141 137.044 109.852 133.105C109.47 127.901 107.279 124.999 108.454 122.636C109.108 121.32 109.869 121.003 110.435 120.992C110.892 120.983 111.266 120.629 111.266 120.172L111.264 120.173Z",
    fill: "url(#paint41_linear_4157_9738)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M124.509 137.884C128.965 138.523 125.533 147.205 130.191 158.936C130.493 159.7 130.839 160.489 131.22 161.295C133.792 163.82 136.884 166.378 139.742 168.564L139.756 168.543C143.591 171.467 146.968 173.699 148.033 174.249C150.165 175.349 149.997 176.834 148.026 176.306C147.014 176.034 142.997 174.288 138.08 171.345L138.051 171.386C134.954 169.523 131.513 167.19 128.249 164.457C128.022 164.267 127.817 164.052 127.636 163.818C127.52 163.669 127.415 163.513 127.321 163.35C126.394 161.743 125.529 160.079 124.765 158.377C119.308 146.226 121.056 137.389 124.508 137.884H124.509Z",
    fill: "url(#paint42_linear_4157_9738)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M112.823 134.498C109.612 135.155 106.584 137.775 106.439 141.187C106.386 141.625 106.36 142.097 106.361 142.604C106.365 144.63 106.816 147.229 107.872 150.625C110.987 160.652 112.545 167.084 112.545 167.084H126.975C126.975 167.084 126.902 165.683 126.969 165.091C127.037 164.498 127.142 163.652 127.251 162.642C127.502 159.133 127.411 157.711 127.912 154.191C127.995 153.601 128.078 153.009 128.16 152.414C128.175 151.058 128.363 149.594 128.527 148.11C128.581 147.614 128.634 147.116 128.675 146.619C129.16 144.14 128.578 141.836 127.316 139.891C127.001 139.403 126.642 138.938 126.246 138.499C123.225 135.642 118.872 133.652 114.513 134.207C113.409 134.274 112.823 134.499 112.823 134.499V134.498Z",
    fill: "url(#paint43_linear_4157_9738)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M126.215 140.607C126.215 140.607 129.812 145.347 130.646 147.475C131.458 149.548 128.189 152.517 128.189 152.517C128.189 152.517 125.754 151.817 125.328 147.498C124.877 142.929 126.215 140.606 126.215 140.606V140.607Z",
    fill: "url(#paint44_linear_4157_9738)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M128.317 152.649C128.244 153.174 128.171 153.696 128.097 154.215C127.761 156.571 127.693 157.963 127.607 159.718C127.482 162.243 127.318 164.639 127.466 167.083H108.377C109.674 164.772 110.978 162.417 110.537 159.861C110.013 156.823 108.502 153.914 107.634 150.912C106.724 147.765 106.109 144.474 106.249 141.175C106.405 137.529 109.642 134.963 112.767 134.317C112.872 134.279 113.463 134.081 114.486 134.02C114.977 133.957 115.483 133.925 115.986 133.925C119.607 133.925 123.399 135.547 126.388 138.375C126.793 138.825 127.159 139.301 127.475 139.791C128.293 141.052 128.532 142.498 128.998 143.887C129.429 145.167 130.335 146.17 130.82 147.411C131.667 149.572 128.452 152.525 128.315 152.649H128.317Z",
    fill: "#078FCA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M114.923 124.777C114.923 124.777 115.39 127.239 115.114 129.805C114.841 132.358 113.625 134.113 113.625 134.113C113.417 134.229 116.315 136.152 117.61 136.504C120.395 137.259 121.602 136.339 121.504 135.473C121.504 135.473 120.491 132.967 120.159 130.165C119.744 126.658 120.511 125.071 120.511 125.071L114.922 124.775L114.923 124.777Z",
    fill: "url(#paint45_linear_4157_9738)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M118.721 115.719C111.727 115.656 111.216 122.098 113.273 124.795C115.159 127.269 115.747 125.97 116.763 127.939C117.547 129.456 120.807 130.741 122.404 130.598C124.002 130.454 125.645 127.543 124.737 122.643C123.821 117.698 121.285 115.743 118.721 115.72V115.719Z",
    fill: "url(#paint46_linear_4157_9738)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M123.326 119.421C122.232 120.098 120.904 120.098 119.687 119.83C119.479 119.82 119.282 119.827 119.094 119.853C118.01 120.001 117.168 120.81 116.851 121.84C116.372 123.393 116.291 124.956 116.051 126.54C116.031 126.673 115.998 126.8 115.954 126.917C115.883 127.104 115.783 127.263 115.647 127.386C115.42 127.53 115.188 127.604 114.959 127.624C113.504 127.511 112.605 126.098 111.832 125.086C111.732 124.909 111.64 124.728 111.56 124.542C111.48 124.356 111.411 124.166 111.355 123.971C111.291 123.798 111.231 123.615 111.176 123.426C110.9 122.482 110.752 121.367 110.906 120.262C110.949 119.972 111.012 119.683 111.101 119.394C111.177 119.186 111.262 118.981 111.356 118.782C112.188 116.49 114.492 115.223 116.87 114.855C117.167 114.809 117.466 114.777 117.764 114.76C119.125 114.576 120.322 114.887 121.522 115.368C121.974 115.611 122.45 115.854 122.848 116.17C122.98 116.276 123.105 116.389 123.218 116.514C123.671 117.112 124.356 118.273 123.586 119.139C123.459 119.285 123.326 119.423 123.326 119.423V119.421Z",
    fill: "url(#paint47_linear_4157_9738)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M116.267 125.127C116.267 125.127 114.693 124.104 114.891 125.634C115.088 127.16 116.674 127.267 116.674 127.267L116.267 125.127Z",
    fill: "url(#paint48_linear_4157_9738)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M110.822 136.549C114.821 138.831 109.033 145.24 108.769 157.714C111.396 156.931 114.058 155.995 116.483 155.064C121.1 153.293 124.863 151.541 125.913 150.901C128.013 149.622 129.245 150.602 127.736 152.056C126.952 152.812 123.204 155.459 117.898 158.218C114.774 159.842 111.11 161.505 107.192 162.844C106.534 163.069 105.802 162.974 105.208 162.594C104.625 162.22 104.237 161.609 104.144 160.927C103.922 159.284 103.764 157.624 103.689 155.964C103.072 142.196 107.649 134.739 110.82 136.548L110.822 136.549Z",
    fill: "url(#paint49_linear_4157_9738)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M119.654 220.183C119.457 218.813 117.729 206.655 116.855 197.73C115.912 188.077 116.284 166.907 116.284 166.907H126.974C126.974 166.907 130.747 188.137 129.874 203.089C129.305 212.819 128.462 219.936 128.263 221.545C128.248 221.673 128.236 221.801 128.23 221.93C128.202 222.452 128.06 223.978 127.315 225.883C126.395 228.237 124.421 267.672 124.421 267.672H119.665C119.665 267.672 117.133 246.064 116.558 237.501C115.994 229.108 119.401 220.79 119.655 220.182L119.654 220.183Z",
    fill: "url(#paint50_linear_4157_9738)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M111.011 234.635C112.284 229.102 114.572 219.916 114.572 219.916C114.572 219.916 115.438 208.186 114.553 200.55C113.668 192.915 115.217 166.907 115.217 166.907L116.617 166.935C116.617 166.918 116.617 166.907 116.617 166.907H127.457C127.457 166.907 130.747 188.137 129.875 203.089C129.307 212.819 128.006 249.021 128.006 249.021C128.006 249.021 126.063 249.907 120.197 249.574C114.333 249.243 109.297 247.915 109.297 247.915C109.297 247.915 109.74 240.168 111.011 234.635Z",
    fill: "url(#paint51_linear_4157_9738)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M124.464 264.181C125.358 264.181 124.612 265.392 126.865 267.08C129.11 268.763 130.928 269.363 130.928 269.363C130.928 269.363 133.164 269.842 133.441 270.56C133.718 271.276 133.433 272.825 133.433 272.825C133.433 272.825 130.924 274.131 126.189 272.825C121.44 271.514 122.421 272.111 120.747 271.992C119.073 271.873 118.647 271.276 118.647 271.276C118.647 271.276 118.607 268.044 119.016 267.081C119.292 266.431 118.698 264.953 118.717 264.059C118.723 263.735 119.093 263.513 119.449 263.62C119.801 263.725 120.97 263.842 121.651 263.94C122.778 264.102 123.716 264.182 124.466 264.182L124.464 264.181Z",
    fill: "#078FCA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8357 237.033C102.04 230.832 106.952 225.615 108.584 223.998C108.011 220.521 106.67 212.067 105.807 204.119C105.194 198.479 105.152 191.094 105.245 185.441C104.915 184.669 104.649 183.794 104.44 182.817C102.715 174.719 108.611 169.541 110.665 167.201L121.929 167.129C121.977 167.129 122.246 171.773 122.197 174.683C122.183 175.57 122.252 177.067 122.154 178.769C122.154 178.769 122.154 178.773 122.154 178.781C122.125 179.279 122.081 179.794 122.016 180.318C121.621 184.713 120.445 197.595 119.353 207.642C118.078 219.37 116.461 227.574 116.461 227.574C116.308 227.891 115.626 229.205 114.13 230.67C112.417 232.348 96.0602 264.91 96.0602 264.91L91.5771 263.461C91.5771 263.461 97.2115 244.415 99.8357 237.032V237.033Z",
    fill: "url(#paint52_linear_4157_9738)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6653 263.166C97.5407 263.326 96.5173 264.378 98.3183 266.436C100.11 268.485 101.746 269.396 101.746 269.396C101.746 269.396 103.817 270.263 103.915 271.015C104.013 271.766 103.361 273.231 103.361 273.231C103.361 273.231 100.591 274.065 96.267 271.945C91.9231 269.815 92.7429 270.574 91.1266 270.159C89.5091 269.743 89.2344 269.083 89.2344 269.083C89.2344 269.083 89.9775 265.902 90.6127 265.031C91.042 264.443 91.4737 263.007 91.7095 262.132C91.7951 261.816 92.2112 261.664 92.5349 261.833C92.8553 262 93.3169 262.205 93.961 262.423C95.0274 262.784 95.9285 263.032 96.6642 263.166H96.6653Z",
    fill: "#078FCA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M100.497 233.308C102.157 229.877 105.92 223.458 105.92 223.458C105.92 223.458 105.699 219.032 105.367 213.278C105.149 209.49 104.307 198.221 104.105 189.132C104.105 189.127 104.105 189.123 104.105 189.118C104.105 189.117 104.105 189.115 104.105 189.114C104.096 188.709 104.088 188.307 104.081 187.911C103.967 184.51 103.601 179.992 104.485 176.372C105.589 171.854 108.476 166.908 108.476 166.908H122.428C122.476 166.908 122.745 171.774 122.696 174.684C122.682 175.571 122.751 177.068 122.653 178.77C122.653 178.77 122.653 178.774 122.653 178.782C122.624 179.28 122.581 179.795 122.516 180.319C122.121 184.714 121.941 197.43 120.849 207.478C120.304 212.497 118.821 217.31 118.443 220.986C117.902 226.241 117.113 231.467 116.082 236.648C114.702 243.587 112.895 252.785 112.895 252.785C112.895 252.785 109.901 253.526 103.309 250.648C96.7183 247.77 95.7783 246.513 95.7783 246.513C95.7783 246.513 98.8397 236.737 100.5 233.308H100.497Z",
    fill: "url(#paint53_linear_4157_9738)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M127.419 165.931L127.641 168.164H107.704L109.014 165.931H127.419Z",
    fill: "url(#paint54_linear_4157_9738)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M123.44 168.281C123.44 168.281 122.25 174.792 123.715 181.237C125.179 187.683 125.004 203.799 125.004 203.799L120.497 205.346C120.497 205.346 120.227 185.814 119.828 181.753C119.427 177.692 120.436 169.892 121.332 168.732C122.227 167.572 123.178 167.378 123.178 167.378L123.44 168.281Z",
    fill: "url(#paint55_linear_4157_9738)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M124.82 167.555C124.82 167.555 123.757 168.522 123.756 168.522C123.837 168.449 125.471 170.446 125.564 170.569C126.7 172.082 127.492 173.58 127.745 175.449C128.099 178.072 128.306 180.715 128.365 183.36C128.417 185.709 127.98 188.263 128.489 190.567C128.944 192.66 129.812 194.379 129.84 194.433C129.711 194.179 131.037 192.281 131.189 192.006C131.9 190.727 132.232 190.485 131.644 189.077C130.021 185.19 129.678 180.941 129.529 176.776C129.463 174.899 128.978 173.239 128.112 171.549C127.918 171.17 125.281 167.135 124.819 167.555H124.82Z",
    fill: "url(#paint56_linear_4157_9738)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M124.44 168.591C124.413 168.593 124.388 168.595 124.361 168.597C123.813 168.631 123.231 168.67 122.701 168.492C122.147 168.305 122.225 167.842 122.37 167.371C122.429 167.177 122.501 167.002 122.519 166.8C122.565 166.272 122.531 165.969 123.158 165.915C123.43 165.89 123.703 165.867 123.976 165.854C124.143 165.847 124.318 165.846 124.47 165.915C124.555 165.952 124.629 166.011 124.696 166.076C125.22 166.582 125.274 167.675 124.915 168.292C124.862 168.382 124.796 168.469 124.706 168.521C124.626 168.566 124.534 168.582 124.441 168.591H124.44Z",
    fill: "url(#paint57_linear_4157_9738)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M149.56 174.586C150.238 175.273 151.255 175.863 150.936 176.287C150.78 176.493 149.886 175.98 149.046 175.551C149.558 176.104 149.96 176.643 150.156 177.027C150.748 178.182 151.618 178.261 151.901 178.474C152.183 178.686 153.399 179.071 153.172 179.431C152.945 179.792 148.976 179.946 147.536 179.038C146.095 178.129 144.001 174.206 144.001 174.206L145.398 173.176C146.27 172.372 148.884 173.898 149.561 174.586H149.56Z",
    fill: "url(#paint58_linear_4157_9738)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M128.737 148.64C128.45 148.194 127.545 148.942 126.665 149.34C125.785 149.737 124.221 150.761 123.676 152.038L127.392 150.157C128.085 149.519 128.879 148.858 128.738 148.64H128.737Z",
    fill: "url(#paint59_linear_4157_9738)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M123.933 163.616L134.703 163.405C135.78 163.384 137.116 162.425 137.68 161.268L146.019 144.175C146.391 143.414 146.358 142.709 145.936 142.318L145.291 141.72C145.084 141.527 144.791 141.423 144.445 141.418C144.424 141.418 144.403 141.418 144.382 141.418L133.612 141.63C132.535 141.651 131.2 142.608 130.635 143.765L122.295 160.859C121.926 161.616 121.958 162.328 122.379 162.718L123.024 163.315L123.026 163.313C123.235 163.506 123.525 163.611 123.87 163.616C123.89 163.616 123.911 163.616 123.933 163.616Z",
    fill: "url(#paint60_linear_4157_9738)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M122.943 161.456L131.282 144.363C131.846 143.206 133.182 142.248 134.259 142.227L145.03 142.016C145.051 142.016 145.072 142.016 145.093 142.016C145.56 142.022 145.926 142.21 146.122 142.545C146.362 142.957 146.326 143.551 146.022 144.174L137.682 161.267C137.117 162.424 135.782 163.383 134.705 163.404L123.935 163.615C123.914 163.615 123.893 163.615 123.873 163.615C123.405 163.609 123.041 163.421 122.844 163.085C122.603 162.673 122.64 162.079 122.944 161.455L122.943 161.456Z",
    fill: "url(#paint61_linear_4157_9738)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M132.464 147.635C132.205 147.297 131.422 148.304 131.125 148.495C130.827 148.687 130.451 149.474 129.162 149.629C128.733 149.68 128.089 149.87 127.393 150.157L123.475 152.132L124.379 154.421C124.379 154.421 128.784 153.821 130.137 152.785C131.49 151.749 132.722 147.973 132.464 147.635Z",
    fill: "url(#paint62_linear_4157_9738)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M379.819 183.952C379.988 185.132 385.585 185.649 385.585 185.649C385.585 185.649 386.739 166.283 385.721 159.31C384.702 152.339 382.762 152.797 382.762 152.797C382.762 152.797 383.527 159.394 382.49 166.319C381.451 173.245 379.266 180.079 379.819 183.952Z",
    fill: "url(#paint63_linear_4157_9738)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M392.969 167.232H384.18C384.139 167.232 381.285 190.445 380.932 194.715C379.712 209.422 382.869 221.424 383.401 223.782C383.404 223.795 383.408 223.809 383.41 223.822C383.567 224.5 383.669 225.195 383.729 225.898C383.775 226.435 383.888 227.035 384.073 227.708C385.112 231.482 385.962 247.09 386.189 252.779C386.416 258.468 386.158 266.723 386.158 266.723H391.383C391.383 266.723 392.851 251.323 393.843 244.247C394.451 239.918 394.323 231.901 392.583 226.68C392.076 225.158 391.88 223.504 392.04 221.852C392.102 221.213 392.141 220.517 392.157 219.758C392.269 214.486 393.877 205.121 394.532 201.999C394.915 200.176 396.445 193.076 396.159 187.194C396.718 186.285 397.137 185.157 397.446 183.819C399.101 176.659 394.661 169.244 392.968 167.23L392.969 167.232Z",
    fill: "#F75D35"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M411.224 244.247C411.184 240.048 409.769 232.379 407.068 227.157C406.123 225.328 405.52 223.323 405.333 221.231C405.292 220.769 405.233 220.278 405.158 219.758C404.394 214.486 404.639 205.121 404.857 201.999C404.973 200.346 405.428 194.358 404.528 188.871C404.278 187.354 404.371 185.79 404.809 184.298C404.855 184.141 404.898 183.981 404.941 183.819C407.042 175.854 402.146 170.183 401.665 167.23H388.012C387.965 167.23 387.805 174.193 387.744 176.735C387.705 178.347 387.833 190.735 388.131 194.715C389.232 209.422 394.86 221.424 395.865 223.782C395.878 223.811 395.89 223.839 395.902 223.868C396.168 224.471 396.403 225.09 396.556 225.737C396.693 226.314 396.938 226.968 397.295 227.709C399.118 231.483 402.729 247.091 403.95 252.78C405.172 258.469 406.846 266.724 406.846 266.724H412.061C412.061 266.724 411.292 251.324 411.224 244.248V244.247Z",
    fill: "#F75D35"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M391.36 266.108C391.36 266.108 391.761 267.136 391.816 268.561C391.843 269.252 391.824 269.923 391.798 270.431C391.773 270.94 391.347 271.415 390.811 271.532C388.019 272.142 381.032 273.584 377.538 273.298C376.697 273.229 375.961 271.331 378.49 270.364C381.02 269.398 386.189 265.594 386.189 265.594L391.361 266.108H391.36Z",
    fill: "url(#paint64_linear_4157_9738)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M412.033 266.108C412.033 266.108 412.435 267.136 412.489 268.561C412.516 269.252 412.497 269.923 412.472 270.431C412.446 270.94 412.02 271.415 411.485 271.532C408.693 272.142 401.706 273.584 398.212 273.298C397.371 273.229 396.634 271.331 399.164 270.364C401.693 269.398 406.697 265.594 406.697 265.594L412.034 266.108H412.033Z",
    fill: "url(#paint65_linear_4157_9738)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M386.945 136.541C382.702 136.971 385.247 148.293 377.904 159.21C375.392 162.934 371.361 166.65 367.661 169.168C363.968 171.722 360.645 172.878 359.609 173.207C357.533 173.853 357.619 175.328 359.523 175.182C360.509 175.083 364.534 174.231 369.408 171.695C373.902 169.372 379.115 165.48 383.033 159.943C391.28 148.233 390.225 135.788 386.944 136.541H386.945Z",
    fill: "url(#paint66_linear_4157_9738)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M371.635 170.942C377.71 166.492 382.367 162.064 383.272 160.144C387.877 150.359 390.651 141.396 389.012 137.764C388.603 136.819 388.024 136.276 387.35 136.188C387.21 136.169 387.064 136.171 386.917 136.191C384.46 136.547 384.088 139.776 383.191 144.421C382.412 148.471 381.108 153.974 377.658 159.034C376.536 160.682 371.664 166.069 368.648 167.581C371.228 170.939 371.636 170.942 371.636 170.942H371.635Z",
    fill: "url(#paint67_linear_4157_9738)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M397.928 134.647C401.15 135.304 404.225 137.924 404.433 141.336C404.493 141.774 404.529 142.246 404.538 142.753C404.57 144.779 404.166 147.378 403.173 150.775C400.239 160.801 398.798 167.233 398.798 167.233H384.367C384.367 167.233 384.415 165.832 384.337 165.24C384.258 164.647 384.139 163.801 384.012 162.791C383.697 159.282 383.761 157.861 383.197 154.34C383.103 153.75 383.009 153.158 382.917 152.563C382.877 151.207 382.662 149.743 382.472 148.259C382.409 147.763 382.347 147.265 382.296 146.768C381.766 144.289 382.306 141.985 383.532 140.04C383.839 139.553 384.19 139.088 384.577 138.648C387.547 135.792 391.863 133.801 396.232 134.357C397.337 134.423 397.928 134.648 397.928 134.648V134.647Z",
    fill: "url(#paint68_linear_4157_9738)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M384.646 140.756C384.646 140.756 381.135 145.496 380.34 147.624C379.565 149.697 382.888 152.666 382.888 152.666C382.888 152.666 385.31 151.966 385.658 147.648C386.026 143.078 384.645 140.755 384.645 140.755L384.646 140.756Z",
    fill: "url(#paint69_linear_4157_9738)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M405.334 179.835C405.325 179.835 405.316 179.835 405.306 179.833L383.089 176.669C382.992 176.656 382.922 176.571 382.931 176.479C383.154 174.209 383.351 171.909 383.663 169.631C384.116 166.331 383.826 163.21 383.601 159.868C383.483 158.111 383.388 156.721 383.01 154.364C382.927 153.845 382.844 153.323 382.761 152.798C382.622 152.674 379.354 149.721 380.161 147.56C380.624 146.319 381.513 145.317 381.92 144.036C382.361 142.647 382.574 141.201 383.368 139.94C383.675 139.451 384.034 138.975 384.43 138.525C387.368 135.697 391.131 134.075 394.752 134.075C395.256 134.075 395.762 134.107 396.255 134.17C397.278 134.231 397.874 134.429 397.979 134.467C401.116 135.113 404.4 137.679 404.621 141.325C404.821 144.624 404.265 147.915 403.413 151.062C402.6 154.064 401.141 156.974 400.672 160.011C400.108 163.659 401.13 166.895 402.576 170.177C403.925 173.236 405.464 176.318 405.517 179.661C405.517 179.712 405.494 179.76 405.453 179.793C405.42 179.821 405.376 179.835 405.332 179.835H405.334Z",
    fill: "url(#paint70_linear_4157_9738)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M397.206 134.194C394.442 135.353 393.114 138.174 391.942 140.756C391.405 142.145 390.795 143.171 390.216 144.032C388.478 146.619 387.02 147.722 388.635 152.666C390.79 159.256 390.562 167.224 390.094 170.876C389.627 174.528 388.735 183.902 390.094 186.768C390.434 187.484 391.572 188.115 393.087 188.658C393.844 188.929 394.697 189.178 395.591 189.406C398.977 190.297 402.298 191.127 405.783 191.459C406.613 180.337 405.119 169.381 404.429 158.371C404.458 157.576 404.521 156.788 404.627 156.006C404.733 155.224 404.881 154.448 405.078 153.675C405.281 152.644 405.519 151.615 405.797 150.588C406.013 149.558 406.205 148.564 406.331 147.611C406.457 146.658 406.515 145.744 406.474 144.876C406.412 143.574 406.124 142.379 405.697 141.307C404.567 138.837 403.073 136.679 400.619 135.352C398.811 134.58 397.205 134.193 397.205 134.193L397.206 134.194Z",
    fill: "url(#paint71_linear_4157_9738)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M389.412 135.208C389.412 135.208 386.695 140.646 384.556 143.007C382.417 145.367 381.31 147.286 381.531 148.318C381.753 149.351 383.876 152.45 384.097 156.268C384.317 160.085 383.736 166.579 383.736 166.579C383.736 166.579 382.744 153.037 380.57 150.087C378.397 147.137 381.612 144.703 381.885 142.601C382.159 140.498 384.844 136.499 386.66 136.072C388.475 135.644 389.413 135.208 389.413 135.208H389.412Z",
    fill: "url(#paint72_linear_4157_9738)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M397.078 134.262C395.927 132.641 395.498 130.633 395.381 128.679C395.361 128.351 395.39 124.265 395.631 124.304C395.631 124.304 392.348 123.771 390.708 125.781C390.605 125.907 390.508 126.03 390.415 126.153C390.323 126.275 390.234 126.396 390.15 126.515C389.516 127.384 389.184 128.38 388.749 129.206C388.684 129.401 388.657 129.51 388.656 129.513C388.686 129.389 388.9 129.431 389.111 129.539C390.179 131.036 390.179 132.861 389.59 134.364C389.545 134.545 389.503 134.72 389.464 134.891C389.426 135.013 389.388 135.135 389.348 135.258C389.308 135.38 389.267 135.501 389.224 135.621C389.141 136.487 390.365 137.407 393.137 136.651C394.426 136.3 397.289 134.377 397.078 134.261V134.262Z",
    fill: "url(#paint73_linear_4157_9738)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M392.603 126.803C391.305 127.03 390.395 128.986 388.175 129.7C386.32 130.296 385.363 129.956 384.805 128.15C384.265 126.403 383.992 118.429 387.61 116.561C391.229 114.694 395.281 114.912 397.022 117.616C398.763 120.32 398.471 125.777 392.603 126.804V126.803Z",
    fill: "url(#paint74_linear_4157_9738)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M396.62 133.407C398.212 133.709 400.362 133.804 398.702 134.965C397.043 136.127 393.229 139.668 394.113 140.332C394.996 140.997 396.711 142.269 394.774 143.265C392.838 144.26 387.973 148.404 387.973 148.404C387.973 148.404 388.117 146.474 389.26 144.759C390.404 143.043 392.592 139.015 393.165 137.732C393.737 136.448 395.934 133.275 396.621 133.407H396.62Z",
    fill: "url(#paint75_linear_4157_9738)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M389.56 134.757C389.56 134.757 388.577 135.228 387.691 135.208C386.806 135.186 386.192 138.23 385.587 139.115C384.98 140.001 385.082 140.444 384.616 140.444C384.149 140.444 383.487 140.609 383.375 141.551C383.265 142.492 381.758 146.968 381.758 146.968C381.758 146.968 384.643 143.266 385.587 142.38C386.53 141.495 388.555 138.243 388.909 136.933C389.264 135.623 389.561 134.758 389.561 134.758L389.56 134.757Z",
    fill: "url(#paint76_linear_4157_9738)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M387.699 115.563C387.699 115.563 388.752 114.107 391.311 113.669C391.824 113.581 392.397 113.535 393.037 113.547C394.158 113.459 395.156 113.648 396.023 114.043C396.457 114.241 396.859 114.49 397.228 114.783C398.645 115.764 399.476 117.424 399.974 119.083C400.41 120.577 400.542 122.235 400.321 123.798C400.247 124.319 400.134 124.83 399.978 125.321C399.309 127.549 397.483 129.043 395.492 130.038C395.326 128.046 392.504 128.379 392.005 127.216C391.176 125.391 392.005 122.9 391.276 120.512C391.048 119.863 390.81 119.331 390.584 118.899C389.903 117.599 389.323 117.186 389.323 117.186L387.699 115.56V115.563Z",
    fill: "url(#paint77_linear_4157_9738)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M388.186 115.063C388.186 115.063 386.529 115.194 385.197 117.186C383.866 119.177 385.409 120.08 385.409 120.08C385.907 120.429 386.718 120.135 389.204 121.243C390.862 121.98 391.861 123.977 391.85 123.969C391.85 123.969 392.702 120.542 391.704 118.143C390.706 115.746 388.185 115.062 388.185 115.062L388.186 115.063Z",
    fill: "url(#paint78_linear_4157_9738)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M401.339 137.447C399.314 139.278 399.841 142.268 400.645 146.871C401.44 151.419 402.509 157.578 401.375 164.456C400.615 169.276 398.63 174.804 396.641 179.119C394.656 183.454 392.691 186.697 392.002 187.556C390.628 189.244 391.433 190.87 392.948 189.804C393.73 189.238 396.608 186.232 399.663 181.175C402.482 176.521 405.429 170.033 406.803 162.585C408.291 154.964 407.668 147.68 406.337 143.01C404.994 138.278 402.943 136.159 401.339 137.448V137.447Z",
    fill: "url(#paint79_linear_4157_9738)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M397.29 176.229C398.7 176.796 401.738 178.28 401.869 178.354C403.162 175.167 406.398 166.456 407.107 162.659C408.501 155.48 408.078 148.526 406.883 143.761C405.687 138.95 403.719 136.328 402.002 136.75C401.725 136.812 401.453 136.946 401.192 137.145C401.185 137.151 401.18 137.155 401.172 137.161C398.524 139.521 399.857 143.654 400.863 150.068C401.486 154.042 401.944 159.105 401.067 164.4C400.719 166.52 398.005 173.982 397.289 176.228L397.29 176.229Z",
    fill: "url(#paint80_linear_4157_9738)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M252.846 75.6149C252.846 62.1302 237.522 52.2231 223.327 62.3316C222.856 62.6664 222.444 63.0791 222.109 63.5497C215.03 73.4801 217.765 83.9602 224.672 89.3542C226.388 90.6947 227.38 92.7604 227.38 94.9374V102.217H243.428V94.993C243.428 92.7916 244.422 90.6969 246.155 89.3398C250.228 86.1494 252.847 81.188 252.847 75.6149H252.846Z",
    fill: "#FFCC51"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M242.193 106.898H228.647C227.836 106.898 227.12 106.32 226.999 105.517C226.848 104.511 227.632 103.638 228.61 103.638H242.157C242.968 103.638 243.683 104.216 243.804 105.019C243.955 106.025 243.171 106.898 242.193 106.898Z",
    fill: "#078FCA"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M242.193 111.579H228.647C227.836 111.579 227.12 111.001 226.999 110.198C226.848 109.192 227.632 108.319 228.61 108.319H242.157C242.968 108.319 243.683 108.897 243.804 109.7C243.955 110.706 243.171 111.579 242.193 111.579Z",
    fill: "#078FCA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M240.719 116.284H230.271C229.374 116.284 228.641 115.55 228.641 114.654C228.641 113.757 229.374 113.024 230.271 113.024H240.719C241.615 113.024 242.348 113.757 242.348 114.654C242.348 115.55 241.615 116.284 240.719 116.284Z",
    fill: "#078FCA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M233.467 102.218H232.787C232.787 102.123 232.829 93.5839 232.298 88.7315C230.785 88.1253 229.243 87.4734 227.886 86.4455C226.871 85.6769 225.858 84.3676 225.882 83.1751C225.896 82.5021 226.234 81.9158 226.86 81.4798C227.326 81.1549 227.965 81.0348 228.61 81.1516C230.023 81.4063 231.108 82.3163 231.838 83.8548C232.461 85.1696 232.726 86.7214 232.886 87.9262C232.9 88.0318 232.914 88.1409 232.927 88.251C233.157 88.3422 233.388 88.4345 233.618 88.528L233.886 88.637C235.305 89.2132 236.765 89.805 238.287 90.102C238.592 89.0553 239.097 88.1086 239.975 87.4578C240.619 86.9806 241.542 86.9239 242.218 87.3199C242.784 87.6514 243.059 88.2321 242.972 88.9129C242.874 89.676 242.278 90.3824 241.454 90.7127C240.677 91.0242 239.849 90.9909 239.213 90.9263C239.071 90.9119 238.93 90.8952 238.788 90.8752C238.59 91.804 238.52 92.8096 238.455 93.7596C238.418 94.2869 238.384 94.7853 238.328 95.248C238.083 97.3049 237.96 99.5675 237.951 102.136H237.271C237.28 99.5397 237.405 97.2504 237.653 95.1679C237.706 94.7219 237.739 94.2324 237.776 93.7129C237.841 92.7785 237.913 91.7462 238.121 90.7628C236.553 90.4524 235.071 89.8517 233.63 89.2677L233.362 89.1587C233.245 89.1109 233.127 89.0642 233.011 89.0174C233.507 93.9632 233.467 102.129 233.467 102.22V102.218ZM238.956 90.2122C239.064 90.2266 239.171 90.2389 239.28 90.25C240.109 90.3334 240.701 90.2811 241.2 90.0809C241.8 89.8406 242.23 89.3478 242.297 88.8261C242.364 88.3099 242.103 88.0407 241.873 87.9061C241.433 87.6481 240.804 87.6892 240.379 88.004C239.658 88.538 239.227 89.32 238.956 90.2133V90.2122ZM228.123 81.7879C227.789 81.7879 227.482 81.8735 227.247 82.0382C226.794 82.3541 226.57 82.7301 226.561 83.1895C226.542 84.1384 227.447 85.2619 228.295 85.9049C229.488 86.8082 230.807 87.3967 232.203 87.9618C231.849 85.3398 231.101 82.2929 228.486 81.8213C228.363 81.799 228.241 81.7879 228.122 81.7879H228.123Z",
    fill: "url(#paint81_linear_4157_9738)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M215.054 52.8448C215.054 40.9831 201.575 32.2685 189.088 41.16C188.674 41.4548 188.312 41.8174 188.017 42.2313C181.79 50.967 184.196 60.1844 190.272 64.93C191.781 66.1091 192.654 67.9257 192.654 69.8413V76.2454H206.77V69.8902C206.77 67.9535 207.643 66.1113 209.168 64.9177C212.751 62.1111 215.055 57.7471 215.055 52.8448H215.054Z",
    fill: "#FFCC51"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M205.685 80.3624H193.769C193.054 80.3624 192.426 79.8529 192.319 79.1477C192.187 78.2633 192.876 77.4946 193.736 77.4946H205.652C206.367 77.4946 206.995 78.0041 207.102 78.7094C207.234 79.5938 206.545 80.3613 205.685 80.3613V80.3624Z",
    fill: "#078FCA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M205.685 84.4794H193.769C193.054 84.4794 192.426 83.9699 192.319 83.2646C192.187 82.3802 192.876 81.6116 193.736 81.6116H205.652C206.367 81.6116 206.995 82.1211 207.102 82.8263C207.234 83.7107 206.545 84.4794 205.685 84.4794Z",
    fill: "#078FCA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M195.178 85.7498H204.487C205.245 85.7498 205.862 86.366 205.862 87.1247V87.2426C205.862 88.0013 205.245 88.6176 204.487 88.6176H195.178C194.419 88.6176 193.803 88.0013 193.803 87.2426V87.1247C193.803 86.366 194.419 85.7498 195.178 85.7498Z",
    fill: "#078FCA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M198.008 76.2453H197.411C197.411 76.1607 197.447 68.6497 196.98 64.3825C195.65 63.8497 194.293 63.2757 193.099 62.3724C192.207 61.6961 191.316 60.5447 191.336 59.4957C191.348 58.9039 191.645 58.3877 192.196 58.004C192.606 57.7181 193.167 57.6135 193.735 57.7159C194.978 57.9406 195.933 58.7404 196.575 60.0931C197.124 61.25 197.356 62.6149 197.497 63.6739C197.51 63.7674 197.522 63.8619 197.534 63.9598C197.737 64.041 197.939 64.1211 198.141 64.2034L198.377 64.2991C199.627 64.8052 200.91 65.3258 202.249 65.5873C202.517 64.6662 202.962 63.8341 203.734 63.2612C204.3 62.8418 205.112 62.7918 205.706 63.14C206.204 63.4314 206.446 63.9431 206.369 64.5405C206.283 65.2113 205.758 65.8331 205.033 66.1234C204.35 66.3971 203.621 66.3682 203.063 66.3114C202.938 66.2992 202.814 66.2836 202.689 66.2669C202.515 67.0846 202.453 67.9689 202.395 68.8032C202.363 69.2671 202.333 69.7054 202.284 70.1125C202.068 71.9213 201.96 73.9125 201.953 76.1718H201.355C201.363 73.8881 201.473 71.8746 201.691 70.0425C201.738 69.6498 201.768 69.2193 201.799 68.7621C201.856 67.94 201.919 67.0323 202.103 66.1679C200.723 65.8943 199.42 65.367 198.153 64.852L197.917 64.7563C197.813 64.714 197.711 64.6729 197.608 64.6317C198.044 68.9823 198.009 76.1652 198.008 76.2441V76.2453ZM202.837 65.684C202.932 65.6963 203.026 65.7074 203.122 65.7174C203.85 65.7908 204.371 65.7452 204.81 65.5695C205.338 65.3581 205.717 64.9254 205.775 64.4648C205.833 64.0099 205.605 63.774 205.402 63.655C205.014 63.4281 204.462 63.4637 204.088 63.7407C203.454 64.2101 203.075 64.8976 202.837 65.684ZM193.308 58.2743C193.016 58.2743 192.744 58.3499 192.537 58.4945C192.139 58.7715 191.941 59.103 191.933 59.5068C191.916 60.3411 192.713 61.3301 193.459 61.8952C194.508 62.6894 195.67 63.2078 196.897 63.7051C196.585 61.3979 195.927 58.7192 193.627 58.3032C193.518 58.2832 193.412 58.2743 193.307 58.2743H193.308Z",
    fill: "url(#paint82_linear_4157_9738)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M279.171 33.7881C279.171 23.1757 267.111 15.3777 255.939 23.3336C255.568 23.5973 255.243 23.9221 254.98 24.2925C249.408 32.1083 251.561 40.3568 256.997 44.6018C258.347 45.6564 259.128 47.2827 259.128 48.9958V54.7258H271.758V49.0403C271.758 47.3083 272.54 45.6597 273.904 44.5907C277.11 42.08 279.171 38.1743 279.171 33.7881Z",
    fill: "#FFCC51"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M270.787 58.4092H260.126C259.487 58.4092 258.924 57.9531 258.83 57.3224C258.711 56.5315 259.328 55.844 260.098 55.844H270.759C271.398 55.844 271.961 56.3001 272.055 56.9308C272.174 57.7217 271.557 58.4092 270.787 58.4092Z",
    fill: "#078FCA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M270.787 62.0935H260.126C259.487 62.0935 258.924 61.6374 258.83 61.0067C258.711 60.2158 259.328 59.5283 260.098 59.5283H270.759C271.398 59.5283 271.961 59.9844 272.055 60.6151C272.174 61.4061 271.557 62.0935 270.787 62.0935Z",
    fill: "#078FCA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M269.697 63.2302H261.474C260.766 63.2302 260.191 63.8045 260.191 64.5128C260.191 65.2212 260.766 65.7954 261.474 65.7954H269.697C270.405 65.7954 270.98 65.2212 270.98 64.5128C270.98 63.8045 270.405 63.2302 269.697 63.2302Z",
    fill: "#078FCA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M263.919 54.7259H263.384C263.384 54.6503 263.418 47.9302 262.999 44.1113C261.809 43.6341 260.594 43.1213 259.526 42.3126C258.728 41.7074 257.931 40.6773 257.949 39.7384C257.959 39.2089 258.226 38.7473 258.718 38.4035C259.085 38.1477 259.586 38.0542 260.095 38.1455C261.207 38.3468 262.062 39.0621 262.636 40.2724C263.126 41.3069 263.334 42.5284 263.461 43.4772C263.472 43.5607 263.483 43.6463 263.493 43.7331C263.675 43.8054 263.856 43.8777 264.037 43.9511L264.249 44.0368C265.367 44.4895 266.515 44.9556 267.711 45.1892C267.952 44.3649 268.349 43.6196 269.04 43.1079C269.547 42.7319 270.272 42.6874 270.804 42.9989C271.25 43.2603 271.466 43.7175 271.397 44.2526C271.32 44.8533 270.851 45.4095 270.202 45.6687C269.591 45.9134 268.938 45.8878 268.439 45.8367C268.327 45.8255 268.215 45.8122 268.105 45.7966C267.95 46.5275 267.895 47.3195 267.843 48.0659C267.814 48.4809 267.787 48.8735 267.744 49.2373C267.551 50.8559 267.455 52.6368 267.447 54.6581H266.912C266.918 52.6146 267.017 50.8125 267.212 49.1739C267.254 48.8235 267.281 48.4375 267.309 48.0292C267.36 47.2939 267.417 46.4819 267.58 45.7076C266.345 45.4629 265.18 44.9901 264.046 44.5307L263.835 44.445C263.742 44.4072 263.65 44.3705 263.558 44.3338C263.948 48.2261 263.917 54.6536 263.916 54.7248L263.919 54.7259ZM268.24 45.276C268.324 45.2871 268.409 45.2971 268.495 45.306C269.146 45.3717 269.613 45.3305 270.005 45.1737C270.477 44.9846 270.816 44.5974 270.868 44.1858C270.921 43.7787 270.716 43.5673 270.535 43.4617C270.188 43.2581 269.694 43.2904 269.359 43.5384C268.792 43.9589 268.452 44.5741 268.24 45.2771V45.276ZM259.713 38.646C259.451 38.646 259.209 38.7139 259.024 38.8429C258.668 39.091 258.491 39.388 258.483 39.7496C258.468 40.496 259.18 41.3804 259.848 41.8865C260.787 42.5973 261.825 43.0612 262.924 43.5062C262.646 41.4426 262.056 39.0443 259.999 38.6727C259.902 38.6549 259.806 38.646 259.712 38.646H259.713Z",
    fill: "url(#paint83_linear_4157_9738)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M449.587 85.2204C448.822 85.1882 448.084 85.2883 447.395 85.4985C447.398 85.414 447.399 85.3294 447.399 85.2449C447.399 81.1757 444.1 77.8763 440.03 77.8763C438.894 77.8763 437.818 78.1344 436.857 78.5938C435.317 76.1988 432.616 74.6203 429.549 74.6559C424.986 74.7081 421.228 78.3924 421.091 82.9544C421.075 83.4873 421.107 84.009 421.184 84.5163C421.034 84.5062 420.881 84.5007 420.728 84.5007C416.8 84.5007 413.637 87.7723 413.813 91.7391C413.979 95.4524 417.11 98.3435 420.827 98.3435H449.307C452.96 98.3435 455.917 95.3578 455.87 91.6935C455.826 88.2306 453.046 85.3661 449.586 85.2226L449.587 85.2204Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M147.625 82.7351C147.042 82.7106 146.479 82.7874 145.954 82.9476C145.956 82.883 145.957 82.8185 145.957 82.754C145.957 79.6515 143.442 77.1363 140.339 77.1363C139.473 77.1363 138.653 77.3321 137.92 77.6825C136.746 75.8571 134.688 74.6534 132.35 74.6801C128.872 74.7191 126.006 77.5279 125.901 81.0053C125.889 81.4113 125.914 81.8096 125.973 82.1967C125.858 82.1889 125.742 82.1856 125.626 82.1856C122.632 82.1856 120.22 84.6796 120.355 87.7031C120.481 90.5342 122.868 92.7379 125.701 92.7379H147.412C150.198 92.7379 152.451 90.4619 152.415 87.6686C152.38 85.0289 150.262 82.8452 147.623 82.7362L147.625 82.7351Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M78.2105 102.621C77.6276 102.596 77.0647 102.673 76.5397 102.833C76.5419 102.769 76.543 102.704 76.543 102.639C76.543 99.537 74.0279 97.0218 70.9254 97.0218C70.0588 97.0218 69.2389 97.2176 68.5059 97.568C67.3323 95.7425 65.2743 94.5389 62.936 94.5656C59.4575 94.6046 56.592 97.4134 56.4874 100.891C56.4752 101.297 56.4996 101.695 56.5586 102.082C56.444 102.074 56.3283 102.071 56.2115 102.071C53.218 102.071 50.8063 104.565 50.9409 107.589C51.0666 110.42 53.4539 112.623 56.2872 112.623H77.9981C80.7835 112.623 83.0373 110.347 83.0006 107.554C82.9661 104.914 80.848 102.731 78.2094 102.622L78.2105 102.621Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M333.335 73.4356C332.662 73.4144 332.012 73.5056 331.404 73.6903C331.406 73.6136 331.408 73.5368 331.408 73.4589C331.408 69.7579 328.408 66.7578 324.707 66.7578C323.673 66.7578 322.695 66.9925 321.82 67.4096C320.42 65.2304 317.963 63.7954 315.174 63.8277C310.952 63.8766 307.506 67.3407 307.48 71.5634C307.478 71.9816 307.508 72.3932 307.569 72.7937C307.432 72.7848 307.294 72.7792 307.154 72.7792C303.606 72.7792 300.743 75.716 300.864 79.2913C300.978 82.6941 303.826 85.3673 307.231 85.3673H333.145C336.428 85.3673 339.093 82.7153 339.113 79.4359C339.133 76.2166 336.552 73.5335 333.335 73.4333V73.4356Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M131.102 59.1788C131.242 55.0195 127.912 51.6033 123.784 51.6033C123.621 51.6033 123.461 51.6089 123.301 51.62C123.374 51.1361 123.41 50.64 123.403 50.1338C123.344 45.2504 119.364 41.2601 114.481 41.1889C111.224 41.1422 108.355 42.8131 106.721 45.3549C105.704 44.8688 104.565 44.5963 103.362 44.5963C99.0571 44.5963 95.5664 48.087 95.5664 52.392C95.5664 52.4821 95.5686 52.5711 95.572 52.6612C94.8645 52.4454 94.1091 52.3397 93.3249 52.3642C89.734 52.4766 86.7917 55.3588 86.6115 58.9463C86.4113 62.9432 89.5928 66.2471 93.5463 66.2471H123.693C127.653 66.2471 130.967 63.1368 131.1 59.1777L131.102 59.1788Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M373.13 33.4289C372.547 33.4045 371.984 33.4812 371.459 33.6414C371.461 33.5769 371.462 33.5124 371.462 33.4478C371.462 30.3453 368.947 27.8302 365.845 27.8302C364.978 27.8302 364.158 28.026 363.425 28.3764C362.252 26.5509 360.193 25.3473 357.855 25.374C354.377 25.4129 351.511 28.2217 351.407 31.6991C351.395 32.1052 351.419 32.5034 351.478 32.8894C351.363 32.8816 351.248 32.8783 351.131 32.8783C348.137 32.8783 345.726 35.3723 345.86 38.3958C345.986 41.2269 348.373 43.4306 351.207 43.4306H372.917C375.703 43.4306 377.957 41.1546 377.92 38.3614C377.886 35.7216 375.767 33.5379 373.129 33.4289H373.13Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M191.276 13.0554C190.693 13.0309 190.13 13.1076 189.605 13.2678C189.607 13.2033 189.609 13.1388 189.609 13.0743C189.609 9.97176 187.093 7.4566 183.991 7.4566C183.124 7.4566 182.305 7.65238 181.571 8.00279C180.398 6.17733 178.339 4.97482 176 5.0004C172.522 5.03933 169.656 7.84817 169.552 11.3256C169.54 11.7316 169.564 12.1298 169.623 12.5158C169.508 12.5081 169.393 12.5047 169.276 12.5047C166.282 12.5047 163.871 14.9987 164.005 18.0223C164.131 20.8533 166.518 23.057 169.352 23.057H191.063C193.848 23.057 196.102 20.781 196.065 17.9878C196.031 15.348 193.913 13.1644 191.274 13.0554H191.276Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M317.323 134.459C312.651 136.758 318.211 148.876 315.209 158.82C315.205 158.834 315.2 158.848 315.196 158.864C309.28 163.464 300.581 167.556 295.579 169.03C293.965 169.542 292.75 169.832 292.157 169.887C289.445 170.118 289.5 172.211 291.924 172.577C292.551 172.665 294.251 172.692 296.662 172.478C298.527 172.311 300.381 172.054 302.218 171.69C304.509 171.236 306.77 170.641 308.988 169.914C311.458 169.104 313.874 168.126 316.199 166.966C317.881 166.127 319.51 165.186 321.077 164.147C321.416 163.921 321.673 163.695 321.832 163.308C322.025 162.836 322.236 162.373 322.425 161.899C322.82 160.905 323.175 159.893 323.485 158.864C328.127 143.172 321.519 131.975 317.324 134.46L317.323 134.459Z",
    fill: "url(#paint84_linear_4157_9738)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M296.411 170.337C296.15 168.928 292.92 169.306 291.83 169.489C290.983 169.659 289.918 169.684 289.48 169.928C288.721 170.355 288.791 174.005 290.736 174.155C292.681 174.306 297.002 172.339 297.002 172.339L296.412 170.335L296.411 170.337Z",
    fill: "url(#paint85_linear_4157_9738)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M322.139 163.433C322.225 163.224 322.314 163.016 322.403 162.809C322.513 162.553 322.627 162.287 322.733 162.021C323.136 161.009 323.495 159.98 323.804 158.958C327.481 146.528 324.137 136.664 320.311 134.322C319.234 133.664 318.117 133.608 317.165 134.168C314.512 135.486 314.894 139.482 315.379 144.54C315.806 148.994 316.29 154.041 314.909 158.667C309.658 162.728 302.29 166.376 297.171 168.166C297.177 168.203 297.782 171.944 298.028 173.412C304.91 172.423 314.074 168.397 316.347 167.263C318.038 166.419 319.691 165.464 321.261 164.424C321.598 164.2 321.938 163.926 322.139 163.434V163.433Z",
    fill: "url(#paint86_linear_4157_9738)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M296.148 168.857L297.211 168.503L297.859 172.388L296.663 172.478L296.148 168.857Z",
    fill: "url(#paint87_linear_4157_9738)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M349.554 265.589C349.554 265.589 350.069 266.642 350.183 268.103C350.239 268.81 350.241 269.498 350.228 270.018C350.215 270.541 349.724 271.027 349.089 271.148C345.781 271.773 337.496 273.25 333.319 272.957C332.314 272.887 331.369 270.942 334.352 269.951C337.334 268.961 343.17 265.062 343.17 265.062L349.554 265.588V265.589Z",
    fill: "#232323"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M326.898 265.589C326.898 265.589 327.421 266.642 327.538 268.103C327.595 268.81 327.596 269.498 327.584 270.018C327.57 270.541 327.072 271.027 326.426 271.148C323.062 271.773 314.64 273.25 310.394 272.957C309.371 272.887 308.411 270.942 311.444 269.951C314.476 268.961 320.61 265.062 320.61 265.062L326.9 265.588L326.898 265.589Z",
    fill: "#232323"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M325.486 164.248H315.388C315.341 164.248 313.08 188.04 312.821 192.416C311.934 207.49 315.891 219.791 316.569 222.208C316.573 222.221 316.577 222.236 316.581 222.249C316.782 222.944 316.92 223.656 317.01 224.377C317.079 224.928 317.227 225.543 317.457 226.232C318.754 230.099 320.229 246.097 320.673 251.928C321.117 257.758 320.607 265.062 320.607 265.062L328.983 266.22C328.983 266.22 329.83 251.048 329.757 243.298C329.715 238.828 329.651 230.531 327.516 225.179C326.895 223.62 326.618 221.924 326.744 220.23C326.793 219.576 326.813 218.862 326.807 218.084C326.759 212.68 327.763 203.082 328.399 199.882C328.674 198.494 329.568 194.124 329.797 189.498C329.929 186.827 330.37 184.185 331.005 181.588C331.032 181.477 331.058 181.365 331.084 181.25C332.712 173.912 327.461 166.313 325.485 164.249L325.486 164.248Z",
    fill: "url(#paint88_linear_4157_9738)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M331.378 130.61C335.291 131.328 339.046 134.089 339.334 137.645C339.412 138.102 339.459 138.594 339.475 139.122C339.536 141.231 339.073 143.935 337.905 147.462C334.456 157.872 333.351 164.555 333.351 164.555L315.288 164.402C315.288 164.402 315.331 162.944 315.23 162.326C314.57 158.304 314.161 154.161 313.594 150.092C312.967 145.595 312.886 140.574 315.124 136.476C317.87 131.452 323.873 129.647 329.32 130.287C330.659 130.368 331.378 130.609 331.378 130.609V130.61Z",
    fill: "url(#paint89_linear_4157_9738)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M331.378 130.61C335.291 131.328 339.046 134.089 339.334 137.645C339.412 138.102 339.459 138.594 339.475 139.122C339.536 141.231 339.073 143.935 337.905 147.462C334.456 157.872 333.351 164.555 333.351 164.555L315.288 164.402C315.288 164.402 315.331 162.944 315.23 162.326C314.57 158.304 314.161 154.161 313.594 150.092C312.967 145.595 312.886 140.574 315.124 136.476C317.87 131.452 323.873 129.647 329.32 130.287C330.659 130.368 331.378 130.609 331.378 130.609V130.61Z",
    fill: "url(#paint90_linear_4157_9738)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M330.179 127.71C329.48 126.555 329.192 124.198 329.198 123.672C329.205 122.38 329.266 119.772 329.464 119.804C329.464 119.804 326.047 119.249 324.34 121.341C324.233 121.472 324.132 121.601 324.035 121.728C323.938 121.856 323.847 121.982 323.759 122.107C323.098 123.011 321.652 125.416 321.652 125.416C321.652 125.416 322.738 125.387 322.876 127.13C322.984 128.489 322.175 131.343 322.175 131.343C322.175 131.343 322.431 132.392 323.621 132.715C323.992 132.876 324.49 132.967 325.122 132.945C325.14 132.946 325.155 132.948 325.173 132.949C328.078 133.163 330.844 131.42 331.259 131.143C331.674 130.866 332.12 130.503 332.12 130.503C332.12 130.503 330.88 128.867 330.18 127.712L330.179 127.71Z",
    fill: "url(#paint91_linear_4157_9738)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M348.904 243.298C347.987 239.089 345.921 231.019 342.703 225.668C341.576 223.793 340.83 221.737 340.549 219.595C340.487 219.121 340.406 218.618 340.304 218.085C339.267 212.681 339.232 203.083 339.376 199.883C339.379 199.801 339.369 199.648 339.347 199.435C339.332 194.779 339.113 187.929 337.674 178.302C336.418 169.907 332.857 164.249 332.857 164.249C332.857 164.249 332.527 164.332 332.493 164.249H319.23C319.177 164.249 319.227 171.385 319.242 173.991C319.252 175.643 319.806 188.338 320.275 192.419C322.003 207.492 328.747 219.793 329.959 222.21C329.974 222.239 329.989 222.268 330.004 222.298C330.324 222.916 330.609 223.551 330.804 224.214C330.977 224.805 331.274 225.475 331.702 226.235C333.883 230.103 338.471 246.1 340.037 251.932C341.602 257.762 343.17 265.066 343.17 265.066L351.229 265.987C351.229 265.987 350.592 251.052 348.905 243.3L348.904 243.298Z",
    fill: "url(#paint92_linear_4157_9738)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M333.657 163.069H315.261V165.69H333.657V163.069Z",
    fill: "url(#paint93_linear_4157_9738)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M331.062 129.046L324.197 132.926L325.561 135.208L332.396 130.567L331.062 129.046Z",
    fill: "url(#paint94_linear_4157_9738)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M327.967 121.103C326.709 121.648 326.409 125.275 322.502 125.883C320.497 126.196 319.386 123.966 318.805 122.087C318.244 120.268 316.922 114.203 320.514 111.954C324.334 109.561 328.276 110.177 330.089 112.992C331.901 115.806 331.124 119.737 327.966 121.104L327.967 121.103Z",
    fill: "url(#paint95_linear_4157_9738)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M331.445 115.481C331.501 114.817 332.219 114.209 331.888 113.241C331.556 112.273 330.947 112.439 330.699 112.134C330.449 111.829 331.141 110.971 330.118 110.004C329.095 109.036 328.486 109.505 327.991 109.256C327.497 109.007 327.351 108.149 325.58 108.426C323.809 108.703 324.17 109.007 323.506 108.979C322.842 108.951 322.095 108.259 320.905 108.841C319.716 109.422 319.743 110.335 319.245 110.28C318.747 110.224 317.945 110.639 317.779 111.608C317.613 112.576 318.183 113.607 318.79 113.923C318.79 113.923 319.611 114.486 320.407 114.43C322.173 114.306 322.824 113.656 324.576 113.877C326.327 114.098 325.995 118.746 326.548 118.857C327.101 118.967 327.765 118.636 328.098 118.415C328.429 118.193 329.344 118.831 328.872 119.737C328.4 120.644 329.176 121.569 329.176 121.569C329.176 121.569 329.62 121.07 330.007 120.6C330.394 120.13 330.643 119.19 330.643 118.857C330.643 118.525 331.501 118 331.556 116.948C331.612 115.897 331.391 116.146 331.445 115.482V115.481Z",
    fill: "url(#paint96_linear_4157_9738)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M327.513 119.002C327.519 118.429 327.866 117.898 328.407 117.708C328.856 117.55 329.318 117.639 329.367 118.629C329.466 120.609 327.49 121.076 327.49 121.076L327.513 119.002Z",
    fill: "url(#paint97_linear_4157_9738)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M321.024 131.048C321.024 131.048 317.427 132.52 316.086 134.354C314.663 136.3 312.572 141.951 312.693 146.372C312.806 150.494 312.505 167.383 312.313 171.367C312.122 175.35 311.31 184.056 311.31 184.056C311.31 184.056 313.081 184.425 314.335 184.572C315.588 184.719 316.831 184.572 316.831 184.572C316.831 184.572 317.554 153.364 317.383 146.43C317.211 139.495 318.097 136.147 318.995 134.368C320.027 132.321 321.027 131.341 321.027 131.341L321.192 131.048H321.023H321.024Z",
    fill: "url(#paint98_linear_4157_9738)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M332.581 130.194C331.629 129.877 327.027 133.517 326.167 139.232C325.307 144.947 324.842 185.089 324.842 185.089C324.842 185.089 333.382 185.655 335.723 185.717C338.969 185.801 341.094 184.925 341.094 184.925C341.094 184.925 343.857 152.042 340.215 136.395C339.212 132.085 336.128 131.378 332.58 130.195L332.581 130.194Z",
    fill: "url(#paint99_linear_4157_9738)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M322.469 130.175L324.198 132.926L322.708 134.875L320.978 131.563L322.469 130.175Z",
    fill: "url(#paint100_linear_4157_9738)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M331.094 134.875L329.721 133.658L331.492 133.465L334.191 130.672L331.667 129.647L331.231 129.942C331.231 129.942 328.523 132.302 327.384 134.664C326.245 137.024 325.86 139.606 325.721 141.82C325.581 144.034 325.573 149.53 325.573 149.53C325.573 149.53 327.795 140.528 329.271 137.835C329.837 136.802 330.472 135.779 331.095 134.875H331.094Z",
    fill: "url(#paint101_linear_4157_9738)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M319.662 131.563L318.258 133.63L318.756 134.114L317.314 134.716C316.882 135.663 316.485 136.831 316.252 138.223C315.533 142.539 317.575 148.544 317.575 148.544C317.575 148.544 317.335 145.174 317.361 143.626C317.388 142.079 317.816 138.426 319.181 135.208C320.546 131.989 322.069 130.543 322.069 130.543L319.663 131.563H319.662Z",
    fill: "url(#paint102_linear_4157_9738)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M305.938 138.618C305.766 138.288 305.771 137.977 305.952 137.8L306.229 137.528C306.317 137.442 306.445 137.391 306.597 137.385C306.606 137.385 306.616 137.385 306.625 137.385H308.592C309.066 137.381 309.666 137.786 309.929 138.288L309.653 138.559L305.938 138.618Z",
    fill: "url(#paint103_linear_4157_9738)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M323.858 159.977L313.085 160.07C312.009 160.079 310.646 159.159 310.05 158.017L301.232 141.167C300.839 140.416 300.852 139.71 301.263 139.308L301.891 138.692C302.094 138.494 302.383 138.381 302.728 138.367C302.749 138.367 302.769 138.366 302.791 138.366L313.564 138.273C314.641 138.264 316.002 139.184 316.6 140.325L325.418 157.175C325.808 157.922 325.796 158.635 325.386 159.036L324.758 159.652L324.756 159.649C324.552 159.848 324.264 159.962 323.92 159.976C323.9 159.976 323.879 159.977 323.858 159.977Z",
    fill: "url(#paint104_linear_4157_9738)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M324.788 157.791L315.97 140.94C315.374 139.8 314.011 138.88 312.934 138.889L302.162 138.981C302.14 138.981 302.119 138.981 302.098 138.982C301.631 139.002 301.272 139.2 301.085 139.541C300.856 139.959 300.909 140.551 301.23 141.166L310.049 158.017C310.646 159.158 312.007 160.078 313.084 160.069L323.857 159.977C323.878 159.977 323.899 159.977 323.919 159.976C324.386 159.956 324.746 159.758 324.933 159.416C325.162 158.998 325.108 158.405 324.786 157.79L324.788 157.791Z",
    fill: "url(#paint105_linear_4157_9738)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M336.105 133.666C331.458 134.277 332.692 146.545 327.262 154.155C321.734 150.884 316.779 146.849 313.986 143.558C312.976 142.417 312.294 141.523 312.032 141.054C310.852 138.908 309.151 139.716 309.735 141.844C309.892 142.393 310.49 143.801 311.545 145.707C312.363 147.18 313.251 148.612 314.221 149.99C315.43 151.709 316.744 153.353 318.152 154.913C319.719 156.649 321.382 158.308 323.208 159.77C323.943 160.359 324.718 160.92 325.583 161.305C325.968 161.476 326.394 161.648 326.814 161.7C327.242 161.752 327.679 161.695 328.095 161.588C328.642 161.447 329.165 161.222 329.664 160.957C330.211 160.665 330.733 160.324 331.207 159.924C331.699 159.509 332.117 159.017 332.534 158.528C333.158 157.795 333.752 157.034 334.314 156.248C342.802 144.211 340.401 132.758 336.107 133.666H336.105Z",
    fill: "url(#paint106_linear_4157_9738)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M338.691 134.412C337.964 133.54 337.028 133.171 336.055 133.372C333.413 133.729 332.585 137.247 331.538 141.698C330.616 145.619 329.572 150.06 327.058 153.606C327.023 153.618 326.987 153.629 326.952 153.641C322.283 150.783 318.208 147.676 315.277 144.555C315.248 144.573 312.392 146.436 311.272 147.174C314.596 152.477 321.252 158.548 323.014 160.003C323.35 160.28 323.815 160.63 324.324 161C325.695 161.989 327.503 162.248 329.098 161.692C331.485 160.859 333.16 158.4 334.554 156.423C341.277 146.89 341.276 137.516 338.69 134.414L338.691 134.412Z",
    fill: "url(#paint107_linear_4157_9738)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M314.336 143.962L315.015 144.709L312.055 146.659L311.544 145.708L314.336 143.962Z",
    fill: "url(#paint108_linear_4157_9738)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M314.565 140.414C314.248 139.356 314.781 138.001 314.113 137.59C313.861 137.435 313.418 138.823 313.386 139.901C313.112 139.083 312.948 138.03 312.659 137.627C312.158 136.927 308.742 137.45 308.859 139.396C308.978 141.341 311.401 145.381 311.401 145.381L313.202 144.546C314.489 144.114 314.883 141.472 314.566 140.414H314.565Z",
    fill: "url(#paint109_linear_4157_9738)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M290.406 175.047C290.2 174.996 290.076 174.788 290.127 174.582L291.97 167.196C292.021 166.99 292.229 166.866 292.435 166.917C292.641 166.968 292.765 167.176 292.714 167.382L290.871 174.768C290.82 174.974 290.612 175.099 290.406 175.047Z",
    fill: "url(#paint110_linear_4157_9738)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M291.986 169.568C291.424 170.203 290.222 170.288 290.588 170.773C290.767 171.01 291.483 171.097 292.237 170.755L295.512 169.313C294.559 168.361 292.548 168.932 291.985 169.568H291.986Z",
    fill: "url(#paint111_linear_4157_9738)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M358.199 172.059C357.286 172.372 356.113 172.445 356.209 172.967C356.256 173.222 357.286 173.161 358.228 173.153C357.523 173.419 356.924 173.723 356.575 173.978C355.531 174.747 354.717 174.43 354.369 174.495C354.021 174.559 352.762 174.361 352.804 174.784C352.847 175.208 356.329 177.117 358.025 176.946C359.72 176.776 363.343 174.2 363.343 174.2L362.553 172.656C362.132 171.547 359.112 171.746 358.198 172.059H358.199Z",
    fill: "url(#paint112_linear_4157_9738)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M389.447 189.066C388.888 189.853 387.977 190.596 388.359 190.964C388.546 191.144 389.347 190.493 390.109 189.938C389.692 190.566 389.381 191.161 389.247 191.572C388.847 192.806 388 193.023 387.754 193.278C387.51 193.532 386.369 194.105 386.651 194.425C386.932 194.744 390.875 194.267 392.154 193.141C393.432 192.015 394.876 187.809 394.876 187.809L393.334 187.014C392.345 186.357 390.007 188.28 389.447 189.066Z",
    fill: "url(#paint113_linear_4157_9738)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4703 271H441.456C441.715 271 441.926 271.211 441.926 271.47V271.741C441.926 272.001 441.715 272.211 441.456 272.211H65.4703C65.2108 272.211 65 272.001 65 271.741V271.47C65 271.211 65.2108 271 65.4703 271Z",
    fill: "#233862"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4157_9738",
    x1: 240.999,
    y1: -9.68421,
    x2: 240.999,
    y2: 332.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4157_9738",
    x1: 252.328,
    y1: 194.9,
    x2: 170.701,
    y2: 285.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4157_9738",
    x1: 252.328,
    y1: 194.9,
    x2: 170.701,
    y2: 285.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4157_9738",
    x1: 251.813,
    y1: 195.116,
    x2: 170.687,
    y2: 285.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4157_9738",
    x1: 251.813,
    y1: 195.116,
    x2: 170.687,
    y2: 285.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4157_9738",
    x1: 279.75,
    y1: 192.182,
    x2: 317.283,
    y2: 310.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4157_9738",
    x1: 279.75,
    y1: 192.182,
    x2: 317.283,
    y2: 310.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4157_9738",
    x1: 279.989,
    y1: 192.1,
    x2: 317.528,
    y2: 310.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4157_9738",
    x1: 279.989,
    y1: 192.1,
    x2: 317.528,
    y2: 310.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4157_9738",
    x1: 136.933,
    y1: 260.593,
    x2: 118.723,
    y2: 273.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4157_9738",
    x1: 159.305,
    y1: 260.487,
    x2: 140.787,
    y2: 274.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4157_9738",
    x1: 237.821,
    y1: 54.6438,
    x2: 164.527,
    y2: 164.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4157_9738",
    x1: 209.414,
    y1: 105.299,
    x2: 209.998,
    y2: 111.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2675EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0744B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4157_9738",
    x1: 191.34,
    y1: 190.88,
    x2: 221.802,
    y2: 85.1688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4157_9738",
    x1: 175.221,
    y1: 168.713,
    x2: 182.703,
    y2: 103.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4157_9738",
    x1: 189.881,
    y1: 212.495,
    x2: 151.023,
    y2: 92.6834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4157_9738",
    x1: 174.97,
    y1: 172.9,
    x2: 170.278,
    y2: 169.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2675EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0744B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4157_9738",
    x1: 187.539,
    y1: 115.258,
    x2: 172.692,
    y2: 117.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4157_9738",
    x1: 183.056,
    y1: 99.3178,
    x2: 174.286,
    y2: 126.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4157_9738",
    x1: 183.152,
    y1: 98.8263,
    x2: 173.781,
    y2: 127.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4157_9738",
    x1: 183.056,
    y1: 99.3178,
    x2: 174.286,
    y2: 126.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4157_9738",
    x1: 177.347,
    y1: 116.547,
    x2: 186.098,
    y2: 121.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4157_9738",
    x1: 171.366,
    y1: 132.268,
    x2: 267.27,
    y2: 50.3248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4157_9738",
    x1: 153.266,
    y1: 182.066,
    x2: 187.046,
    y2: 174.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4157_9738",
    x1: 182.88,
    y1: 137.521,
    x2: 164.486,
    y2: 238.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4157_9738",
    x1: 205.836,
    y1: 198.816,
    x2: 259.12,
    y2: 152.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4157_9738",
    x1: 249.676,
    y1: 276.616,
    x2: 261.42,
    y2: 264.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4157_9738",
    x1: 248.928,
    y1: 260.55,
    x2: 261.984,
    y2: 283.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4157_9738",
    x1: 272.576,
    y1: 275.56,
    x2: 284.027,
    y2: 264.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4157_9738",
    x1: 269.265,
    y1: 256.115,
    x2: 282.349,
    y2: 279.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4157_9738",
    x1: 203.434,
    y1: 161.483,
    x2: 258.91,
    y2: 147.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4157_9738",
    x1: 254.808,
    y1: 192.461,
    x2: 221.922,
    y2: 97.4651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4157_9738",
    x1: 253.212,
    y1: 199.255,
    x2: 208.751,
    y2: 100.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4157_9738",
    x1: 258.897,
    y1: 99.3913,
    x2: 266.644,
    y2: 204.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4157_9738",
    x1: 287.114,
    y1: 163.635,
    x2: 243.768,
    y2: 114.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4157_9738",
    x1: 255.344,
    y1: 124.249,
    x2: 273.05,
    y2: 124.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4157_9738",
    x1: 256.831,
    y1: 102.773,
    x2: 282.988,
    y2: 152.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4157_9738",
    x1: 209.858,
    y1: 233.511,
    x2: 273.191,
    y2: 164.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4157_9738",
    x1: 265.525,
    y1: 213.801,
    x2: 290.054,
    y2: 14.6688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4157_9738",
    x1: 213.43,
    y1: 207.646,
    x2: 266.715,
    y2: 161.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4157_9738",
    x1: 224.331,
    y1: 246.773,
    x2: 287.665,
    y2: 177.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4157_9738",
    x1: 89.0131,
    y1: 140.212,
    x2: 126.791,
    y2: 118.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4157_9738",
    x1: 93.3367,
    y1: 213.275,
    x2: 156.68,
    y2: 123.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4157_9738",
    x1: 123.438,
    y1: 191.343,
    x2: 156.306,
    y2: 96.3442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4157_9738",
    x1: 124.288,
    y1: 198.165,
    x2: 168.749,
    y2: 99.4881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4157_9738",
    x1: 93.3481,
    y1: 162.186,
    x2: 136.264,
    y2: 113.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4157_9738",
    x1: 122.546,
    y1: 123.163,
    x2: 104.839,
    y2: 123.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4157_9738",
    x1: 121.237,
    y1: 109.153,
    x2: 103.42,
    y2: 142.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4157_9738",
    x1: 98.624,
    y1: 118.406,
    x2: 127.028,
    y2: 133.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4157_9738",
    x1: 142.383,
    y1: 178.54,
    x2: 51.2103,
    y2: 100.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4157_9738",
    x1: 131.544,
    y1: 339.778,
    x2: 112.068,
    y2: 147.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4157_9738",
    x1: 169.119,
    y1: 65.9022,
    x2: 100.935,
    y2: 269.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4157_9738",
    x1: 124.536,
    y1: 153.767,
    x2: 63.0728,
    y2: 365.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4157_9738",
    x1: 144.188,
    y1: 99.6773,
    x2: 67.4886,
    y2: 347.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4157_9738",
    x1: 117.672,
    y1: 154.145,
    x2: 117.672,
    y2: 178.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4157_9738",
    x1: 122.507,
    y1: 207.262,
    x2: 122.213,
    y2: 170.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4157_9738",
    x1: 132.524,
    y1: 199.697,
    x2: 125.293,
    y2: 165.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4157_9738",
    x1: 125.148,
    y1: 179.33,
    x2: 123.598,
    y2: 166.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4157_9738",
    x1: 102.268,
    y1: 145.616,
    x2: 183.563,
    y2: 200.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4157_9738",
    x1: 149.476,
    y1: 170.26,
    x2: 58.3027,
    y2: 92.1684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4157_9738",
    x1: 140.14,
    y1: 170.106,
    x2: 129.011,
    y2: 143.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F117E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0552"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_4157_9738",
    x1: 130.178,
    y1: 143.225,
    x2: 139.352,
    y2: 174.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F117E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0552"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4157_9738",
    x1: 150.069,
    y1: 169.566,
    x2: 58.8959,
    y2: 91.4753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_4157_9738",
    x1: 395.884,
    y1: 93.4288,
    x2: 375.743,
    y2: 223.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_4157_9738",
    x1: 431.266,
    y1: 258.852,
    x2: 446.395,
    y2: 270.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_4157_9738",
    x1: 452.339,
    y1: 258.806,
    x2: 467.468,
    y2: 270.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_4157_9738",
    x1: 394.766,
    y1: 133.856,
    x2: 333.859,
    y2: 214.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_4157_9738",
    x1: 356.787,
    y1: 202.355,
    x2: 438.366,
    y2: 38.6088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_4157_9738",
    x1: 387.006,
    y1: 191.644,
    x2: 354.12,
    y2: 96.6492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_4157_9738",
    x1: 382.423,
    y1: 198.324,
    x2: 337.964,
    y2: 99.6488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_4157_9738",
    x1: 385.36,
    y1: 129.652,
    x2: 414.179,
    y2: 228.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_4157_9738",
    x1: 410.798,
    y1: 79.8196,
    x2: 390.554,
    y2: 210.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_4157_9738",
    x1: 394.398,
    y1: 78.1443,
    x2: 372.495,
    y2: 219.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_4157_9738",
    x1: 374.14,
    y1: 127.644,
    x2: 399.675,
    y2: 131.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_4157_9738",
    x1: 384.098,
    y1: 121.729,
    x2: 398.041,
    y2: 124.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_4157_9738",
    x1: 394.237,
    y1: 141.414,
    x2: 343.443,
    y2: 123.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_4157_9738",
    x1: 383.917,
    y1: 140.394,
    x2: 405.275,
    y2: 146.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_4157_9738",
    x1: 391.085,
    y1: 112.983,
    x2: 399.423,
    y2: 129.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_4157_9738",
    x1: 386.522,
    y1: 115.224,
    x2: 394.859,
    y2: 132.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_4157_9738",
    x1: 407.406,
    y1: 130.311,
    x2: 385.147,
    y2: 241.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_4157_9738",
    x1: 377.841,
    y1: 207.796,
    x2: 453.308,
    y2: 46.9274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_4157_9738",
    x1: 269.297,
    y1: 108.667,
    x2: 233.301,
    y2: 92.7707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_4157_9738",
    x1: 229.526,
    y1: 81.9174,
    x2: 197.862,
    y2: 67.9345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_4157_9738",
    x1: 292.119,
    y1: 59.8007,
    x2: 263.789,
    y2: 47.2906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_4157_9738",
    x1: 242.216,
    y1: 194.059,
    x2: 353.726,
    y2: 119.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_4157_9738",
    x1: 339.124,
    y1: 192.696,
    x2: 214.305,
    y2: 136.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_4157_9738",
    x1: 276.4,
    y1: 202.937,
    x2: 366.946,
    y2: 89.2269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_4157_9738",
    x1: 294.089,
    y1: 170.214,
    x2: 300.533,
    y2: 170.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_4157_9738",
    x1: 195.586,
    y1: 237.987,
    x2: 341.224,
    y2: 211.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_4157_9738",
    x1: 319.943,
    y1: 190.229,
    x2: 290.206,
    y2: 87.0362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_4157_9738",
    x1: 319.943,
    y1: 190.229,
    x2: 290.206,
    y2: 87.0362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_4157_9738",
    x1: 331.462,
    y1: 168.803,
    x2: 324.142,
    y2: 104.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_4157_9738",
    x1: 323.771,
    y1: 264.713,
    x2: 358.077,
    y2: 116.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_4157_9738",
    x1: 322.964,
    y1: 170.271,
    x2: 327.345,
    y2: 153.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_4157_9738",
    x1: 328.442,
    y1: 142.388,
    x2: 327.623,
    y2: 82.5661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_4157_9738",
    x1: 312.803,
    y1: 126.254,
    x2: 329.015,
    y2: 113.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_4157_9738",
    x1: 296.963,
    y1: 78.785,
    x2: 346.097,
    y2: 138.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_4157_9738",
    x1: 333.222,
    y1: 117.024,
    x2: 325.222,
    y2: 120.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_4157_9738",
    x1: 319.811,
    y1: 77.2767,
    x2: 313.949,
    y2: 202.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_4157_9738",
    x1: 337.72,
    y1: 75.1931,
    x2: 331.692,
    y2: 203.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_4157_9738",
    x1: 322.717,
    y1: 141.739,
    x2: 321.945,
    y2: 85.2593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_4157_9738",
    x1: 332.034,
    y1: 140.004,
    x2: 308.112,
    y2: 137.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_4157_9738",
    x1: 314.188,
    y1: 140.757,
    x2: 346.594,
    y2: 133.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_4157_9738",
    x1: 309.95,
    y1: 139.651,
    x2: 311.049,
    y2: 136.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_4157_9738",
    x1: 309.328,
    y1: 166.691,
    x2: 319.712,
    y2: 140.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_4157_9738",
    x1: 364.721,
    y1: 61.3851,
    x2: 275.866,
    y2: 212.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#663650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_4157_9738",
    x1: 276.074,
    y1: 145.72,
    x2: 407.59,
    y2: 150.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_4157_9738",
    x1: 290.849,
    y1: 197.643,
    x2: 402.919,
    y2: 37.4128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_4157_9738",
    x1: 312.484,
    y1: 142.766,
    x2: 314.317,
    y2: 148.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_4157_9738",
    x1: 350.936,
    y1: 152.048,
    x2: 244.713,
    y2: 122.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_4157_9738",
    x1: 310.966,
    y1: 186.469,
    x2: 258.135,
    y2: 144.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2675EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0744B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_4157_9738",
    x1: 326.69,
    y1: 166.221,
    x2: 242.071,
    y2: 193.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_4157_9738",
    x1: 325.92,
    y1: 182.657,
    x2: 394.058,
    y2: 165.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_4157_9738",
    x1: 429.298,
    y1: 161.535,
    x2: 351.652,
    y2: 220.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMembers);
export default __webpack_public_path__ + "static/media/team-members.73ebc5e36dc41992f3435a3bf21813cb.svg";
export { ForwardRef as ReactComponent };